import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Card, Row, Col, Modal, Button, Spinner } from 'react-bootstrap';
import ApiTcpServer from 'services/ApiTcpServer';
import ApiMServer from 'services/ApiMServer';
import comandos from 'utils/comandos.json';
import { Page } from 'components';
import Header from '../../../../components/Header/Header';

// Importar componentes filhos
import {
  ResponsePanel,
  ConfigButtons,
  CategorySidebar,
  OperationButtons,
  CommandButton,
  CalibrationSection,
  CommandHistoryPanel
} from './components';

// Importar modais
import {
  BatchConfigModal,
  DialCapxModal,
  CalibrationTableModal,
  CommandParamModal
} from './modals';
import ApiGServer from 'services/ApiGServer';

const ConectedIot = () => {
  const history = useHistory();
  const allowedCommands = comandos.map(c => c.cmd);

  // Regras de validação por comando, espelhando limites do firmware (TASK_RECEIVE_SERIAL)
  const paramValidation = {
    // Operação / Tampa
    TAMPA: [{ type: 'int', min: 0, max: 1 }],

    // Configurações gerais
    // NSERIE: serial em 5 dígitos (00000–99999) no front;
    // no firmware ele é tratado como inteiro, então aqui limitamos ao range visual.
    NSERIE: [{ type: 'int', min: 0, max: 99999 }],
    TPFIM: [{ type: 'int', min: 1, max: 65000 }],
    TPSTAB: [{ type: 'int', min: 1, max: 65000 }],
    TDOSAN: [{ type: 'int', min: 1, max: 65000 }],
    RETST: [{ type: 'int', min: 1, max: 65000 }],
    DLNEWSTRT: [{ type: 'int', min: 1, max: 360000 }],
    TABERT: [{ type: 'int', min: 4000, max: 65000 }],

    // Hardware (motor / sensores / timeouts)
    FTAMPA: [{ type: 'int', min: 8, max: 15 }],
    FTAMPF: [{ type: 'int', min: 8, max: 15 }],
    TOUTTA: [{ type: 'int', min: 1, max: 65000 }],
    TOUTTF: [{ type: 'int', min: 1, max: 65000 }],
    TOUTS2: [{ type: 'int', min: 100, max: 60000 }],
    LIMADA: [{ type: 'int', min: 1, max: 4095 }],
    LIMADF: [{ type: 'int', min: 1, max: 4095 }],

    // OSC1
    FRQVZ1: [{ type: 'int', min: 1, max: 16700000 }],
    RANGE1: [{ type: 'int', min: 1, max: 65000 }],
    MMOVEL1: [{ type: 'int', min: 1, max: 50 }],
    OFFSET1: [{ type: 'float', min: -65000, max: 65000 }],
    UMIRAN1: [
      { type: 'float', min: -200, max: 200, exclusive: true },
      { type: 'float', min: -200, max: 200, exclusive: true },
    ],

    // OSC2
    FRQVZ2: [{ type: 'int', min: 1, max: 16700000 }],
    RANGE2: [{ type: 'int', min: 1, max: 65000 }],
    MMOVEL2: [{ type: 'int', min: 1, max: 50 }],
    OFFSET2: [{ type: 'float', min: -65000, max: 65000 }],
    UMIRAN2: [
      { type: 'float', min: -200, max: 200, exclusive: true },
      { type: 'float', min: -200, max: 200, exclusive: true },
    ],

    // Calibração OSC1
    CALDIAL1: [
      { type: 'int', min: 1, max: 10 },
      { type: 'float', min: -65000, max: 65000, upperExclusive: true },
    ],
    CALCAPX1: [
      { type: 'int', min: 1, max: 10 },
      { type: 'float', min: -65000, max: 65000, upperExclusive: true },
    ],
    CHART1: [
      { type: 'int', min: 1, max: 4 },
      { type: 'float', min: -65000, max: 65000, upperExclusive: true },
    ],

    // Calibração OSC2
    CALDIAL2: [
      { type: 'int', min: 1, max: 10 },
      { type: 'float', min: -65000, max: 65000, upperExclusive: true },
    ],
    CALCAPX2: [
      { type: 'int', min: 1, max: 10 },
      { type: 'float', min: -65000, max: 65000, upperExclusive: true },
    ],
    CHART2: [
      { type: 'int', min: 1, max: 4 },
      { type: 'float', min: -65000, max: 65000, upperExclusive: true },
    ],
  };

  const { id: serialFromUrl } = useParams();
  const [selectedCmd, setSelectedCmd] = useState('');
  const [paramValues, setParamValues] = useState({});
  const [result, setResult] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [retConfig, setRetConfig] = useState(null);
  const [retCalib, setRetCalib] = useState(null);
  const [showParamModal, setShowParamModal] = useState(false);
  const [modalCmdObj, setModalCmdObj] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [activeCategory, setActiveCategory] = useState('operacao');

  const [commandFeedback, setCommandFeedback] = useState({});
  const [commandLogs, setCommandLogs] = useState([]);
  const [terminalLogs, setTerminalLogs] = useState([]);
  const [showBatchModal, setShowBatchModal] = useState(false);
  const [batchParams, setBatchParams] = useState({});
  const [showCalibModal, setShowCalibModal] = useState(false);
  const [calibOsc, setCalibOsc] = useState('1');
  const [calibTable, setCalibTable] = useState(Array(10).fill().map((_, i) => ({
    idx: i + 1,
    caldial: '',
    calcapx: '',
    chart: i < 4 ? '' : null,
    offset: ''
  })));
  const [showDialCapxModal, setShowDialCapxModal] = useState(false);
  const [dialCapxTable, setDialCapxTable] = useState(Array(10).fill().map((_, i) => ({
    idx: i + 1,
    caldial: '',
    calcapx: ''
  })));
  const [showDialCapx2Modal, setShowDialCapx2Modal] = useState(false);
  const [dialCapx2Table, setDialCapx2Table] = useState(Array(10).fill().map((_, i) => ({
    idx: i + 1,
    caldial: '',
    calcapx: ''
  })));
  const [showRebootModal, setShowRebootModal] = useState(false);
  const [showResetModal, setShowResetModal] = useState(false);
  const [showCategoryChangeWarningModal, setShowCategoryChangeWarningModal] = useState(false);
  const [showDiscardChangesModal, setShowDiscardChangesModal] = useState(false);
  const [showBatchSaveConfirmModal, setShowBatchSaveConfirmModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [importData, setImportData] = useState(null);
  const [importOptions, setImportOptions] = useState({ config: true, calib: true });
  const [showConflictModal, setShowConflictModal] = useState(false);
  const [showSaveConfigModal, setShowSaveConfigModal] = useState(false);
  const [showLoadConfigModal, setShowLoadConfigModal] = useState(false);
  const [savedConfigs, setSavedConfigs] = useState([]);
  const [configDescription, setConfigDescription] = useState('');
  const [loadingConfigs, setLoadingConfigs] = useState(false);
  const [showViewConfigModal, setShowViewConfigModal] = useState(false);
  const [viewConfigData, setViewConfigData] = useState(null);
  const [showDeleteConfigModal, setShowDeleteConfigModal] = useState(false);
  const [deleteConfigData, setDeleteConfigData] = useState(null);
  const [deletingConfig, setDeletingConfig] = useState(false);

  // Estados para armazenar valores originais (antes de editar)
  const [originalDialCapxTable, setOriginalDialCapxTable] = useState([]);
  const [originalDialCapx2Table, setOriginalDialCapx2Table] = useState([]);
  const [originalCalibTable, setOriginalCalibTable] = useState([]);

  // Estados para gerenciar alterações pendentes (novo sistema de batch)
  const [pendingChanges, setPendingChanges] = useState({});
  const [showBatchSaveButton, setShowBatchSaveButton] = useState(false);
  const [isSavingBatch, setIsSavingBatch] = useState(false);

  // Estados para WebSocket (monitoramento em tempo real)
  const [socket, setSocket] = useState(null);
  const [realtimeData, setRealtimeData] = useState(null);
  const [socketConnected, setSocketConnected] = useState(false);

  // Usar refs para valores que precisam ser acessados em closures
  const reconnectAttemptRef = useRef(0);
  const intentionalDisconnectRef = useRef(false);

  // Verifica se o equipamento está liberado para configuração (sts = 96)
  const isInStandby = useMemo(() => {
    return realtimeData?.sts === 96;
  }, [realtimeData?.sts]);

  // Verifica se o equipamento precisa reiniciar (sts = 97)
  const needsReboot = useMemo(() => {
    return realtimeData?.sts === 97;
  }, [realtimeData?.sts]);

  // Mapeamento de comandos para valores do retConfig
  const cmdToConfigMap = {
    NSERIE: 'ns',
    TPFIM: 't_fim',
    TPSTAB: 't_stb',
    TDOSAN: 't_dsa',
    RETST: 't_rst',
    TOUTTA: 't_oa',
    TOUTTF: 't_of',
    TOUTS2: 't_os2',
    LIMADA: 'lm_a',
    LIMADF: 'lm_f',
    FTAMPA: 'fr_a',
    FTAMPF: 'fr_f',
    FRQVZ1: 'o1_fv',
    RANGE1: 'o1_rg',
    MMOVEL1: 'o1_mm',
    OFFSET1: 'o1_of',
    FRQVZ2: 'o2_fv',
    RANGE2: 'o2_rg',
    MMOVEL2: 'o2_mm',
    OFFSET2: 'o2_of',
    DLNEWSTRT: 'dl_st',
    TABERT: 't_ini',
  };

  const criticalCommands = ['RBOOT', 'RESET'];
  const calibrationCommands = ['CALDIAL1', 'CALCAPX1', 'CHART1', 'CALDIAL2', 'CALCAPX2', 'CHART2', 'UMIRAN1', 'UMIRAN2'];

  // Atualiza tabela de calibração quando retCalib muda ou calibOsc muda
  useEffect(() => {
    if (retCalib && showCalibModal) {
      const suffix = calibOsc === '2' ? '2' : '';
      const ddKey = calibOsc === '2' ? 'dd2' : 'dd';
      const cpKey = calibOsc === '2' ? 'cp2' : 'cp';
      const umKey = calibOsc === '2' ? 'um2' : 'um';

      const ddValues = retCalib[ddKey] ? retCalib[ddKey].split('$').filter(v => v) : [];
      const cpValues = retCalib[cpKey] ? retCalib[cpKey].split('$').filter(v => v) : [];
      const umValues = retCalib[umKey] ? retCalib[umKey].split('$').filter(v => v) : [];

      const newTable = Array(10).fill().map((_, i) => ({
        idx: i + 1,
        caldial: ddValues[i] || '',
        calcapx: cpValues[i] || '',
        chart: i < 4 ? (umValues[i] || '') : null,
        offset: ''
      }));

      setCalibTable(newTable);
      setOriginalCalibTable(JSON.parse(JSON.stringify(newTable))); // Cópia profunda
    }
  }, [retCalib, calibOsc, showCalibModal]);

  useEffect(() => {
    // Carrega automaticamente a configuração ao acessar o equipamento
    const loadInitialConfig = async () => {
      try {
        addTerminalLog('info', 'SISTEMA', '🚀 Iniciando carregamento da configuração do equipamento...');
        
        // Primeiro: Envia comando SETTING para o equipamento parar e responder apenas comandos
        /*     console.log('📤 Enviando SETTING...');
            const resSetting = await ApiTcpServer.post('/api/enviar-comando', {
              serial: serialFromUrl,
              comando: 'SETTING',
              param1: '',
              param2: '',
            });
            console.log('✅ Resposta SETTING recebida:', resSetting.data); */

        // Carrega configuração
        console.log('📤 Enviando RETCONFIG...');
        addTerminalLog('command', 'COMANDO', 'RETCONFIG');
        const resConfig = await ApiTcpServer.post('/api/enviar-comando', {
          serial: serialFromUrl,
          comando: 'RETCONFIG',
          param1: '',
          param2: '',
        });
        const respConfig = resConfig.data?.result || resConfig.data?.error || JSON.stringify(resConfig.data);
        console.log('✅ Resposta RETCONFIG recebida:', respConfig);

        // Parse da configuração
        try {
          let jsonString = typeof respConfig === 'string' ? respConfig : JSON.stringify(respConfig);

          // Só tenta parsear se parecer JSON (começa com { ou [)
          if (jsonString.trim().startsWith('{') || jsonString.trim().startsWith('[')) {
            // Remove zeros à esquerda de números no JSON (firmware envia 00002 que é inválido em JSON)
            jsonString = jsonString.replace(/:\s*0+(\d+)/g, ':$1');
            const obj = JSON.parse(jsonString);
            console.log('Objeto RETCONFIG parseado:', obj);

            if (obj && obj.pr === 'config' && obj.cfg) {
              console.log('✅ Configuração detectada e salva:', obj.cfg);
              setRetConfig(obj.cfg);
              setResult(respConfig);
              addTerminalLog('success', 'SUCESSO', 'Configuração carregada com sucesso!');
            } else {
              console.log('⚠️ Resposta não contém configuração válida');
              setResult(respConfig);
              addTerminalLog('warning', 'AVISO', 'Resposta não contém configuração válida');
            }
          } else {
            console.log('⚠️ Resposta não é JSON, exibindo como texto');
            setResult(respConfig);
            addTerminalLog('warning', 'AVISO', 'Resposta não é JSON válido');
          }
        } catch (err) {
          console.error('❌ Erro ao parsear configuração inicial:', err);
          setResult(respConfig);
          addTerminalLog('error', 'ERRO', 'Erro ao parsear configuração: ' + err.message);
        }

        // Carrega calibração
        console.log('📤 Enviando RETCALIB...');
        addTerminalLog('command', 'COMANDO', 'RETCALIB');
        const resCalib = await ApiTcpServer.post('/api/enviar-comando', {
          serial: serialFromUrl,
          comando: 'RETCALIB',
          param1: '',
          param2: '',
        });
        const respCalib = resCalib.data?.result || resCalib.data?.error || JSON.stringify(resCalib.data);
        console.log('✅ Resposta RETCALIB recebida:', respCalib);

        // Parse da calibração
        try {
          let jsonString = typeof respCalib === 'string' ? respCalib : JSON.stringify(respCalib);
          const calibData = JSON.parse(jsonString);

          if (calibData && calibData.pr === 'calib') {
            // console.log('✅ Calibração detectada e salva:', calibData);
            setRetCalib(calibData);
            addTerminalLog('success', 'SUCESSO', 'Calibração carregada com sucesso!');
          } else {
            console.log('⚠️ Resposta não contém calibração válida');
            addTerminalLog('warning', 'AVISO', 'Resposta não contém calibração válida');
          }
        } catch (err) {
          console.error('❌ Erro ao parsear calibração inicial:', err);
          addTerminalLog('error', 'ERRO', 'Erro ao parsear calibração: ' + err.message);
        }

        console.log('✅ Todos os comandos iniciais foram enviados e processados com sucesso');
        addTerminalLog('success', 'SISTEMA', '✅ Sistema inicializado com sucesso! Pronto para receber comandos.');
      } catch (err) {
        console.error('Erro ao carregar dados iniciais:', err);
        addTerminalLog('error', 'ERRO', 'Erro ao carregar dados iniciais: ' + err.message);
      }
    };

    // Se não há comando pendente, carrega a configuração inicial
    loadInitialConfig();
  }, [serialFromUrl]);

  useEffect(() => {
    if (comandos.length > 0) {
      setSelectedCmd(comandos[0].cmd);
    }
  }, []);

  // Monitora alterações pendentes para exibir botão de salvar
  useEffect(() => {
    const hasPendingChanges = Object.keys(pendingChanges).length > 0;
    setShowBatchSaveButton(hasPendingChanges);
  }, [pendingChanges]);

  // Gerencia conexão WebSocket para monitoramento em tempo real
  useEffect(() => {
    const maxReconnectAttempts = 5;
    const reconnectDelay = 3000; // 3 segundos
    let ws = null;
    let reconnectTimeout = null;
    let pingInterval = null;

    const connectWebSocket = () => {
      try {
        // Converte base URL HTTP para WS
        const baseURL = process.env.REACT_APP_API_TCP_SERVER;
        const wsURL = baseURL.replace('https://', 'wss://').replace('http://', 'ws://');
        const socketURL = `${wsURL}/socket/equipment/${serialFromUrl}`;

        ws = new WebSocket(socketURL);

        ws.onopen = () => {
          console.log('✅ WebSocket conectado');
          setSocket(ws);
          setSocketConnected(true);
          reconnectAttemptRef.current = 0; // Reseta tentativas de reconexão ao conectar com sucesso
          addTerminalLog('success', 'CONEXÃO', '✅ Conectado ao monitoramento em tempo real');
        };

        ws.onmessage = (event) => {
          try {
            const message = JSON.parse(event.data);

            console.log('📩 Mensagem WebSocket recebida:', message);

            // Exibe mensagens do tipo 'result' (dados do equipamento) no terminal
            if (message.type === 'result') {
              addTerminalLog('info', 'RESULTADO', JSON.stringify(message, null, 2));
            }

            // Verifica se a mensagem tem os campos de status do equipamento
            if (message.serial && message.sts !== undefined) {
              // Atualiza dados em tempo real APENAS se houver mudança
              setRealtimeData(prevData => {
                // Se não há dados anteriores, atualiza
                if (!prevData) return message;

                // Verifica se houve mudança nos campos relevantes
                const hasChanged =
                  prevData.sts !== message.sts ||
                  prevData.err !== message.err ||
                  prevData.statusMsg !== message.statusMsg ||
                  prevData.errorMsg !== message.errorMsg ||
                  prevData.rebooted !== message.rebooted;

                // Só atualiza se mudou
                return hasChanged ? message : prevData;
              });
            }

            // Se receber configuração, atualiza retConfig
            if (message.type === 'config' && message.cfg) {
              setRetConfig(message.cfg);
            }

            // Se receber calibração, atualiza retCalib
            if (message.type === 'calib' || message.pr === 'calib') {
              setRetCalib(message);
            }
          } catch (err) {
            console.error('Erro ao parsear mensagem WebSocket:', err);
          }
        };

        ws.onerror = (error) => {
          console.error('❌ Erro no WebSocket:', error);
          setSocketConnected(false);
        };

        ws.onclose = () => {
          console.log('🔌 WebSocket desconectado');
          setSocket(null);
          setSocketConnected(false);
          addTerminalLog('warning', 'CONEXÃO', '🔌 Desconectado do monitoramento em tempo real');

          if (pingInterval) {
            clearInterval(pingInterval);
            pingInterval = null;
          }

          // Tenta reconectar automaticamente (apenas se não foi desconexão intencional)
          if (!intentionalDisconnectRef.current && reconnectAttemptRef.current < maxReconnectAttempts) {
            reconnectAttemptRef.current += 1;
            console.log(`🔄 Tentando reconectar (${reconnectAttemptRef.current}/${maxReconnectAttempts})...`);
            addTerminalLog('info', 'CONEXÃO', `🔄 Tentando reconectar... (${reconnectAttemptRef.current}/${maxReconnectAttempts})`);

            reconnectTimeout = setTimeout(() => {
              connectWebSocket();
            }, reconnectDelay);
          } else {
            if (!intentionalDisconnectRef.current) {
              console.log('⚠️ Máximo de tentativas de reconexão atingido.');
              addTerminalLog('error', 'CONEXÃO', '⚠️ Máximo de tentativas de reconexão atingido');
            }
          }
        };
      } catch (error) {
        console.error('Erro ao criar WebSocket:', error);
      }
    };

    // Inicia conexão
    connectWebSocket();

    // Cleanup ao desmontar componente
    return () => {
      console.log('🧹 Limpando WebSocket...');
      if (reconnectTimeout) {
        clearTimeout(reconnectTimeout);
      }
      if (pingInterval) {
        clearInterval(pingInterval);
      }
      if (ws && ws.readyState === WebSocket.OPEN) {
        ws.close();
      }
    };
  }, [serialFromUrl]);

  const sendCommand = useCallback(async (cmd, params = {}, skipAutoRefresh = false, skipLoadingToggle = false) => {
    // Valida comando antes de enviar
    if (!allowedCommands.includes(cmd)) {
      const errorMsg = 'Comando não permitido para este equipamento.';
      setError(errorMsg);
      addTerminalLog('error', 'ERRO', errorMsg);
      return Promise.reject(new Error('Comando não permitido'));
    }

    // Remove feedback antigo deste comando
    setCommandFeedback(prev => ({ ...prev, [cmd]: null }));

    // Só ativa loading se não estiver em modo batch (onde já foi ativado antes)
    if (!skipLoadingToggle) {
      setLoading(true);
    }
    setResult('');
    setError('');
    const param1 = String(params[0] || '');
    const param2 = String(params[1] || '');
    
    // Log do comando sendo enviado
    const paramsStr = param1 || param2 ? ` (${[param1, param2].filter(p => p).join(', ')})` : '';
    addTerminalLog('command', 'COMANDO', `${cmd}${paramsStr}`);
    
    try {
      const res = await ApiTcpServer.post('/api/enviar-comando', {
        serial: serialFromUrl,
        comando: cmd,
        param1,
        param2,
      });
      const resp = res.data?.result || res.data?.error || JSON.stringify(res.data);
      console.log('Resposta bruta (sendCommand):', resp);
      console.log('Tipo da resposta:', typeof resp);
      setResult(resp);
      
      // Log da resposta recebida
      const respStr = typeof resp === 'string' ? resp : JSON.stringify(resp);
      addTerminalLog('success', 'RESPOSTA', respStr);

      // Se for resposta do RETCALIB, salva para visualização
      if (cmd === 'RETCALIB') {
        try {
          let jsonString = typeof resp === 'string' ? resp : JSON.stringify(resp);
          const calibData = JSON.parse(jsonString);
          if (calibData && calibData.pr === 'calib') {
            console.log('RETCALIB parseado:', calibData);
            setRetCalib(calibData);
          }
        } catch (err) {
          console.error('Erro ao parsear RETCALIB:', err);
          setRetCalib(null);
        }
      }

      // Se for resposta do RETCONFIG, salva para visualização
      if (cmd === 'RETCONFIG') {
        try {
          let jsonString = typeof resp === 'string' ? resp : JSON.stringify(resp);

          // Só tenta parsear se parecer JSON (começa com { ou [)
          if (jsonString.trim().startsWith('{') || jsonString.trim().startsWith('[')) {
            // Remove zeros à esquerda de números no JSON (firmware envia 00002 que é inválido em JSON)
            jsonString = jsonString.replace(/:\s*0+(\d+)/g, ':$1');
            const obj = JSON.parse(jsonString);
            console.log('Objeto parseado (sendCommand):', obj);
            console.log('obj.pr:', obj?.pr, 'obj.cfg:', obj?.cfg);
            if (obj && obj.pr === 'config' && obj.cfg) {
              console.log('Detectou config! Salvando:', obj.cfg);
              setRetConfig(obj.cfg);
            } else {
              console.log('Não detectou config');
            }
          } else {
            console.log('Resposta não é JSON, ignorando parse');
          }
        } catch (err) {
          console.error('Erro ao parsear (sendCommand):', err);
        }
      }

      // Feedback de sucesso
      setCommandFeedback(prev => ({ ...prev, [cmd]: { type: 'success', time: Date.now() } }));
      addLog(cmd, params, resp, true);
      setTimeout(() => {
        setCommandFeedback(prev => ({ ...prev, [cmd]: null }));
      }, 3000);

      // Se for comando de calibração, aguarda 2s e atualiza com RETCALIB (apenas se não for envio em lote)
      if (!skipAutoRefresh && calibrationCommands.includes(cmd)) {
        setTimeout(() => {
          sendCommand('RETCALIB');
        }, 2000);
      }

      // Se for comando de configuração, aguarda 2s e atualiza com RETCONFIG (apenas se não for envio em lote)
      const configurationCommands = ['NSERIE', 'TPFIM', 'TPSTAB', 'TDOSAN', 'RETST', 'DLNEWSTRT', 'TABERT',
        'FTAMPA', 'FTAMPF', 'TOUTTA', 'TOUTTF', 'TOUTS2', 'LIMADA', 'LIMADF',
        'FRQVZ1', 'RANGE1', 'MMOVEL1', 'OFFSET1',
        'FRQVZ2', 'RANGE2', 'MMOVEL2', 'OFFSET2'];
      if (!skipAutoRefresh && configurationCommands.includes(cmd)) {
        setTimeout(() => {
          sendCommand('RETCONFIG');
        }, 2000);
      }
    } catch (err) {
      const errorMsg = err.message || 'Erro ao enviar comando';
      setError(errorMsg);
      setRetConfig(null);
      setCommandFeedback(prev => ({ ...prev, [cmd]: { type: 'error', time: Date.now() } }));
      addLog(cmd, params, errorMsg, false);
      addTerminalLog('error', 'ERRO', `${cmd}: ${errorMsg}`);
      setTimeout(() => {
        setCommandFeedback(prev => ({ ...prev, [cmd]: null }));
      }, 3000);
      throw err; // Re-lança o erro para que o caller possa tratá-lo
    } finally {
      // Só desativa loading se não estiver em modo batch
      if (!skipLoadingToggle) {
        setLoading(false);
      }
      setShowParamModal(false);
      setParamValues({});
    }
  }, [allowedCommands, serialFromUrl, calibrationCommands, isInStandby]);

  const handleCategoryChange = async (categoryId) => {
    // Verifica se há alterações pendentes
    if (Object.keys(pendingChanges).length > 0) {
      setShowCategoryChangeWarningModal(true);
      return;
    }

    console.log('📂 Categoria selecionada:', categoryId);
    setActiveCategory(categoryId);
    if (categoryId === 'calibracao') {
      console.log('🎯 Enviando comando RETCALIB...');
      await sendCommand('RETCALIB');
    }
    if (categoryId === 'configuracao') {
      console.log('⚙️ Enviando comando RETCONFIG...');
      await sendCommand('RETCONFIG');
    }
  };

  const handleCmdChange = async (cmdObj) => {
    // Tratamento especial para RBOOT - mostra modal de confirmação
    if (cmdObj.cmd === 'RBOOT') {
      setShowRebootModal(true);
      return;
    }

    // Tratamento especial para RESET - mostra modal de confirmação
    if (cmdObj.cmd === 'RESET') {
      setShowResetModal(true);
      return;
    }

    // Confirmação extra para outros comandos críticos de sistema
    if (criticalCommands.includes(cmdObj.cmd)) {
      const ok = window.confirm(`Tem certeza que deseja executar o comando crítico "${cmdObj.label}"?`);
      if (!ok) return;
    }

    if (cmdObj.params > 0) {
      setModalCmdObj(cmdObj);
      setShowParamModal(true);
      setSelectedCmd(cmdObj.cmd);

      // Primeiro, verifica se há valor pendente para este comando
      const hasPendingChange = pendingChanges[cmdObj.cmd];

      if (hasPendingChange) {
        // Se há alteração pendente, pré-preenche com os valores pendentes
        setParamValues(hasPendingChange.params);
      }
      // Pré-preenche campos com valores de calibração (CALDIAL1, CALCAPX1, CHART1)
      else if (retCalib && ['CALDIAL1', 'CALCAPX1', 'CHART1', 'CALDIAL2', 'CALCAPX2', 'CHART2'].includes(cmdObj.cmd)) {
        const isOsc2 = cmdObj.cmd.endsWith('2');

        if (cmdObj.cmd.startsWith('CALDIAL')) {
          const ddKey = isOsc2 ? 'dd2' : 'dd';
          const ddValues = retCalib[ddKey] ? retCalib[ddKey].split('$').filter(v => v) : [];
          const prefilledValues = {};
          ddValues.forEach((val, idx) => {
            if (val && val !== '0.0') prefilledValues[idx] = val;
          });
          setParamValues(prefilledValues);
        } else if (cmdObj.cmd.startsWith('CALCAPX')) {
          const cpKey = isOsc2 ? 'cp2' : 'cp';
          const cpValues = retCalib[cpKey] ? retCalib[cpKey].split('$').filter(v => v) : [];
          const prefilledValues = {};
          cpValues.forEach((val, idx) => {
            if (val && val !== '0.0') prefilledValues[idx] = val;
          });
          setParamValues(prefilledValues);
        } else if (cmdObj.cmd.startsWith('CHART')) {
          const umKey = isOsc2 ? 'um2' : 'um';
          const umValues = retCalib[umKey] ? retCalib[umKey].split('$').filter(v => v) : [];
          const prefilledValues = {};
          umValues.forEach((val, idx) => {
            if (val && val !== '0.0' && idx < 4) prefilledValues[idx] = val;
          });
          setParamValues(prefilledValues);
        }
      }
      // Pré-preenche UMIRAN1 com valores de rg1/rg2 do retCalib
      else if ((cmdObj.cmd === 'UMIRAN1' || cmdObj.cmd === 'UMIRAN2') && cmdObj.params === 2 && retCalib) {
        const rgKey = cmdObj.cmd === 'UMIRAN2' ? 'rg2' : 'rg1';
        const rgValues = retCalib[rgKey] ? retCalib[rgKey].split('$').filter(v => v) : [];
        if (rgValues.length >= 2) {
          setParamValues({ 0: rgValues[0], 1: rgValues[1] });
        }
      }
      // Pré-preenche campos com valores atuais do retConfig (se existirem)
      else if (retConfig) {
        const configKey = cmdToConfigMap[cmdObj.cmd];
        if (configKey && retConfig[configKey] !== undefined) {
          const currentValue = retConfig[configKey];
          // Para comandos com 1 parâmetro, preenche o primeiro campo
          if (cmdObj.params === 1) {
            setParamValues({ 0: String(currentValue) });
          }
          // Para NSERIE, formata com 5 dígitos
          if (cmdObj.cmd === 'NSERIE') {
            const formatted = String(currentValue).padStart(5, '0');
            setParamValues({ 0: formatted });
          }
        }
      }
    } else {
      // Para comandos sem parâmetros, envia diretamente e aguarda resposta
      await sendCommand(cmdObj.cmd);
    }
  };

  const addLog = (cmd, params, result, success) => {
    const log = {
      timestamp: new Date().toLocaleString(),
      command: cmd,
      params: JSON.stringify(params),
      result: typeof result === 'string' ? result : JSON.stringify(result),
      success
    };
    setCommandLogs(prev => [log, ...prev].slice(0, 100)); // Mantém últimos 100 logs
  };

  // Função helper para adicionar log ao terminal
  const addTerminalLog = (type, label, message) => {
    const timestamp = new Date().toLocaleTimeString('pt-BR');
    setTerminalLogs(prev => [...prev, { timestamp, type, label, message }]);
  };

  const exportLogsCSV = () => {
    const headers = ['Data/Hora', 'Comando', 'Parâmetros', 'Resultado', 'Status'];
    const rows = commandLogs.map(log => [
      log.timestamp,
      log.command,
      log.params,
      log.result.substring(0, 100),
      log.success ? 'Sucesso' : 'Erro'
    ]);
    const csv = [headers, ...rows].map(row => row.map(cell => `"${cell}"`).join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `logs_${serialFromUrl}_${Date.now()}.csv`;
    link.click();
  };

  // Função para desconectar socket e voltar
  const handleGoBack = () => {
    // Marca como desconexão intencional para impedir reconexão automática
    intentionalDisconnectRef.current = true;

    // Desconecta o WebSocket
    if (socket) {
      console.log('🔌 Desconectando WebSocket...');
      socket.close();
      setSocket(null);
      setSocketConnected(false);
    }

    // Volta para a página anterior
    history.goBack();
  };

  // Função para atualizar configuração e calibração sequencialmente
  const handleUpdateConfigAndCalib = async () => {
    if (!isInStandby) {
      const errorMsg = 'Equipamento não está liberado para configuração. Necessário estar no modo "Liberado para configuração".';
      setError(errorMsg);
      addTerminalLog('error', 'ERRO', errorMsg);
      return;
    }

    try {
      setLoading(true);
      setError('');
      addTerminalLog('info', 'INFO', 'Iniciando atualização de configuração e calibração...');

      // Primeira etapa: Enviar RETCONFIG
      await sendCommand('RETCONFIG');

      // Aguarda um pouco para garantir que a resposta foi processada
      await new Promise(resolve => setTimeout(resolve, 1500));

      // Segunda etapa: Enviar RETCALIB
      await sendCommand('RETCALIB');

      // Aguarda um pouco para garantir que a resposta foi processada
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      addTerminalLog('success', 'SUCESSO', 'Configuração e calibração atualizadas com sucesso!');

    } catch (error) {
      console.error('❌ Erro ao atualizar:', error);
      const errorMsg = 'Não foi possível atualizar a configuração e calibração.';
      setError(errorMsg);
      addTerminalLog('error', 'ERRO', errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const exportConfigJSON = () => {
    if (!retConfig && !retCalib) {
      const errorMsg = 'Nenhuma configuração disponível para exportar.';
      setError(errorMsg);
      addTerminalLog('error', 'ERRO', errorMsg);
      return;
    }

    const exportData = {
      equipamento: {
        serial: serialFromUrl,
        dataExportacao: new Date().toISOString(),
        dataExportacaoLocal: new Date().toLocaleString('pt-BR')
      },
      configuracao: retConfig || {},
      calibracao: retCalib || {},
      alteracoesPendentes: Object.keys(pendingChanges).length > 0 ? pendingChanges : null
    };

    const jsonString = JSON.stringify(exportData, null, 2);
    const blob = new Blob([jsonString], { type: 'application/json;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `config_${serialFromUrl}_${Date.now()}.json`;
    link.click();

    const successMsg = `✅ Configurações exportadas com sucesso!`;
    setResult(successMsg);
    addTerminalLog('success', 'SISTEMA', successMsg);
  };

  const handleImportFile = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Valida se é JSON
    if (!file.name.endsWith('.json')) {
      setError('❌ Arquivo inválido. Selecione um arquivo JSON.');
      addTerminalLog('error', 'ERRO', 'Arquivo inválido. Selecione um arquivo JSON.');
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = JSON.parse(e.target.result);

        // Valida estrutura do arquivo
        if (!data.equipamento || !data.equipamento.serial) {
          setError('❌ Arquivo JSON inválido. Estrutura não reconhecida.');
          addTerminalLog('error', 'ERRO', 'Arquivo JSON inválido. Estrutura não reconhecida.');
          return;
        }

        // Valida serial
        if (data.equipamento.serial !== serialFromUrl) {
          setError(`❌ Serial incompatível! Arquivo: ${data.equipamento.serial} | Equipamento atual: ${serialFromUrl}`);
          addTerminalLog('error', 'ERRO', `Serial incompatível! Arquivo: ${data.equipamento.serial} | Equipamento atual: ${serialFromUrl}`);
          return;
        }

        // Verifica se há dados para importar
        const hasConfig = data.configuracao && Object.keys(data.configuracao).length > 0;
        const hasCalib = data.calibracao && Object.keys(data.calibracao).length > 0;

        if (!hasConfig && !hasCalib) {
          setError('❌ Arquivo não contém configurações ou calibrações para importar.');
          addTerminalLog('error', 'ERRO', 'Arquivo não contém configurações ou calibrações para importar.');
          return;
        }

        // Verifica se há conflito com alterações pendentes
        if (Object.keys(pendingChanges).length > 0) {
          setImportData(data);
          setShowConflictModal(true);
        } else {
          // Abre modal de confirmação diretamente
          setImportData(data);
          setImportOptions({ config: hasConfig, calib: hasCalib });
          setShowImportModal(true);
        }

        addTerminalLog('info', 'SISTEMA', `📂 Arquivo carregado: ${file.name}`);
      } catch (err) {
        setError('❌ Erro ao ler arquivo JSON: ' + err.message);
        addTerminalLog('error', 'ERRO', 'Erro ao ler arquivo JSON: ' + err.message);
      }
    };

    reader.onerror = () => {
      setError('❌ Erro ao ler o arquivo.');
      addTerminalLog('error', 'ERRO', 'Erro ao ler o arquivo.');
    };

    reader.readAsText(file);

    // Limpa o input para permitir selecionar o mesmo arquivo novamente
    event.target.value = '';
  };

  const confirmImport = () => {
    if (!importData) return;

    const newPendingChanges = {};
    let configCount = 0;
    let calibCount = 0;

    // Importa configurações se selecionado
    if (importOptions.config && importData.configuracao) {
      const config = importData.configuracao;

      // Mapeia configurações para comandos
      Object.entries(cmdToConfigMap).forEach(([cmd, configKey]) => {
        if (config[configKey] !== undefined) {
          newPendingChanges[cmd] = {
            cmd,
            params: { 0: String(config[configKey]) },
            label: comandos.find(c => c.cmd === cmd)?.label || cmd,
            timestamp: Date.now()
          };
          configCount++;
        }
      });
    }

    // Importa calibrações se selecionado
    if (importOptions.calib && importData.calibracao) {
      const calib = importData.calibracao;

      // CALDIAL1 e CALCAPX1
      if (calib.dd) {
        const ddValues = calib.dd.split('$').filter(v => v);
        ddValues.forEach((val, idx) => {
          if (val && val !== '0.0') {
            const changeKey = `CALDIAL1_${idx + 1}`;
            newPendingChanges[changeKey] = {
              cmd: 'CALDIAL1',
              params: { 0: String(idx + 1), 1: String(val) },
              label: `CALDIAL1 Ponto ${idx + 1}`,
              timestamp: Date.now()
            };
            calibCount++;
          }
        });
      }

      if (calib.cp) {
        const cpValues = calib.cp.split('$').filter(v => v);
        cpValues.forEach((val, idx) => {
          if (val && val !== '0.0') {
            const changeKey = `CALCAPX1_${idx + 1}`;
            newPendingChanges[changeKey] = {
              cmd: 'CALCAPX1',
              params: { 0: String(idx + 1), 1: String(val) },
              label: `CALCAPX1 Ponto ${idx + 1}`,
              timestamp: Date.now()
            };
            calibCount++;
          }
        });
      }

      // CHART1
      if (calib.um) {
        const umValues = calib.um.split('$').filter(v => v);
        umValues.slice(0, 4).forEach((val, idx) => {
          if (val && val !== '0.0') {
            const changeKey = `CHART1_${idx + 1}`;
            newPendingChanges[changeKey] = {
              cmd: 'CHART1',
              params: { 0: String(idx + 1), 1: String(val) },
              label: `CHART1 Coef. ${idx + 1}`,
              timestamp: Date.now()
            };
            calibCount++;
          }
        });
      }

      // UMIRAN1
      if (calib.rg1) {
        const rgValues = calib.rg1.split('$').filter(v => v);
        if (rgValues.length >= 2) {
          newPendingChanges['UMIRAN1'] = {
            cmd: 'UMIRAN1',
            params: { 0: rgValues[0], 1: rgValues[1] },
            label: 'UMIRAN1 (Faixa OSC1)',
            timestamp: Date.now()
          };
          calibCount++;
        }
      }

      // CALDIAL2 e CALCAPX2
      if (calib.dd2) {
        const ddValues = calib.dd2.split('$').filter(v => v);
        ddValues.forEach((val, idx) => {
          if (val && val !== '0.0') {
            const changeKey = `CALDIAL2_${idx + 1}`;
            newPendingChanges[changeKey] = {
              cmd: 'CALDIAL2',
              params: { 0: String(idx + 1), 1: String(val) },
              label: `CALDIAL2 Ponto ${idx + 1}`,
              timestamp: Date.now()
            };
            calibCount++;
          }
        });
      }

      if (calib.cp2) {
        const cpValues = calib.cp2.split('$').filter(v => v);
        cpValues.forEach((val, idx) => {
          if (val && val !== '0.0') {
            const changeKey = `CALCAPX2_${idx + 1}`;
            newPendingChanges[changeKey] = {
              cmd: 'CALCAPX2',
              params: { 0: String(idx + 1), 1: String(val) },
              label: `CALCAPX2 Ponto ${idx + 1}`,
              timestamp: Date.now()
            };
            calibCount++;
          }
        });
      }

      // CHART2
      if (calib.um2) {
        const umValues = calib.um2.split('$').filter(v => v);
        umValues.slice(0, 4).forEach((val, idx) => {
          if (val && val !== '0.0') {
            const changeKey = `CHART2_${idx + 1}`;
            newPendingChanges[changeKey] = {
              cmd: 'CHART2',
              params: { 0: String(idx + 1), 1: String(val) },
              label: `CHART2 Coef. ${idx + 1}`,
              timestamp: Date.now()
            };
            calibCount++;
          }
        });
      }

      // UMIRAN2
      if (calib.rg2) {
        const rgValues = calib.rg2.split('$').filter(v => v);
        if (rgValues.length >= 2) {
          newPendingChanges['UMIRAN2'] = {
            cmd: 'UMIRAN2',
            params: { 0: rgValues[0], 1: rgValues[1] },
            label: 'UMIRAN2 (Faixa OSC2)',
            timestamp: Date.now()
          };
          calibCount++;
        }
      }
    }

    // Adiciona as alterações pendentes
    setPendingChanges(prev => ({ ...prev, ...newPendingChanges }));

    const totalCount = configCount + calibCount;
    const successMsg = `✅ Importação concluída! ${totalCount} alteração(ões) adicionada(s) (${configCount} config, ${calibCount} calib). Clique em "Salvar Todas as Alterações" para aplicar.`;
    setResult(successMsg);
    addTerminalLog('success', 'SISTEMA', successMsg);

    // Fecha modal e limpa dados
    setShowImportModal(false);
    setImportData(null);
    setImportOptions({ config: true, calib: true });
  };

  const handleConflictReplace = () => {
    // Substitui alterações pendentes
    setPendingChanges({});
    setShowConflictModal(false);
    setShowImportModal(true);
    addTerminalLog('warning', 'SISTEMA', '🗑️ Alterações pendentes descartadas para importar novo arquivo.');
  };

  const handleConflictMerge = () => {
    // Mantém alterações e mescla
    setShowConflictModal(false);
    setShowImportModal(true);
    addTerminalLog('info', 'SISTEMA', '🔀 Alterações do arquivo serão mescladas com as pendentes.');
  };

  // Salvar configuração no banco de dados
  const handleSaveToDatabase = () => {
    if (!retConfig && !retCalib) {
      setError('❌ Nenhuma configuração disponível para salvar.');
      addTerminalLog('error', 'ERRO', 'Nenhuma configuração disponível para salvar.');
      return;
    }
    setConfigDescription('');
    setShowSaveConfigModal(true);
  };

  const confirmSaveToDatabase = async () => {
    try {
      setLoading(true);
      addTerminalLog('info', 'SISTEMA', '💾 Salvando configuração no banco de dados...');

      const dataToSave = {
        serial: serialFromUrl,
        descricao: configDescription || `Configuração ${new Date().toLocaleString('pt-BR')}`,
        configuracao: retConfig || {},
        calibracao: retCalib || {},
        alteracoesPendentes: Object.keys(pendingChanges).length > 0 ? pendingChanges : null,
        timestamp: new Date().toISOString()
      };

      const response = await ApiGServer.post('/config-equipment/v1/save', dataToSave);

      if (response.status === 200 || response.status === 201) {
        const successMsg = '✅ Configuração salva no banco de dados com sucesso!';
        setResult(successMsg);
        addTerminalLog('success', 'SISTEMA', successMsg);
        setShowSaveConfigModal(false);
        setConfigDescription('');
      } else {
        throw new Error('Erro ao salvar configuração');
      }
    } catch (err) {
      const errorMsg = '❌ Erro ao salvar configuração no banco de dados: ' + err.message;
      setError(errorMsg);
      addTerminalLog('error', 'ERRO', errorMsg);
    } finally {
      setLoading(false);
    }
  };

  // Buscar configurações do banco de dados
  const handleLoadFromDatabase = async () => {
    try {
      setLoadingConfigs(true);
      addTerminalLog('info', 'SISTEMA', '🔍 Buscando configurações salvas...');

      const response = await ApiGServer.get(`/config-equipment/v1/list?serial=${serialFromUrl}`);

      if (response.status === 200 && response.data) {
        const configs = Array.isArray(response.data) ? response.data : [response.data];
        
        if (configs.length === 0) {
          setError('ℹ️ Nenhuma configuração salva encontrada para este equipamento.');
          addTerminalLog('warning', 'AVISO', 'Nenhuma configuração salva encontrada.');
          return;
        }

        setSavedConfigs(configs);
        setShowLoadConfigModal(true);
        addTerminalLog('success', 'SISTEMA', `✅ ${configs.length} configuração(ões) encontrada(s).`);
      } else {
        throw new Error('Erro ao buscar configurações');
      }
    } catch (err) {
      const errorMsg = '❌ Erro ao buscar configurações do banco de dados: ' + err.message;
      setError(errorMsg);
      addTerminalLog('error', 'ERRO', errorMsg);
    } finally {
      setLoadingConfigs(false);
    }
  };

  const confirmLoadFromDatabase = async (configData) => {
    try {
      setLoading(true);
      setShowLoadConfigModal(false);
      addTerminalLog('info', 'SISTEMA', `📥 Aplicando configuração: ${configData.descricao || 'Sem descrição'}...`);

      const data = configData;

        // Prepara os comandos para envio direto
        const commandsToSend = [];
        let successCount = 0;
        let errorCount = 0;
        let hasConfigChanges = false;
        let hasCalibChanges = false;

        // Comandos de configuração
        const configurationCommands = ['NSERIE', 'TPFIM', 'TPSTAB', 'TDOSAN', 'RETST', 'DLNEWSTRT', 'TABERT',
          'FTAMPA', 'FTAMPF', 'TOUTTA', 'TOUTTF', 'TOUTS2', 'LIMADA', 'LIMADF',
          'FRQVZ1', 'RANGE1', 'MMOVEL1', 'OFFSET1',
          'FRQVZ2', 'RANGE2', 'MMOVEL2', 'OFFSET2', 'TAMPA'];

        // Prepara comandos de configuração
        if (data.configuracao) {
          const config = data.configuracao;
          Object.entries(cmdToConfigMap).forEach(([cmd, configKey]) => {
            if (config[configKey] !== undefined) {
              commandsToSend.push({
                cmd,
                params: { 0: String(config[configKey]) },
                label: comandos.find(c => c.cmd === cmd)?.label || cmd
              });
              if (configurationCommands.includes(cmd)) {
                hasConfigChanges = true;
              }
            }
          });
        }

        // Prepara comandos de calibração
        if (data.calibracao) {
          const calib = data.calibracao;
          hasCalibChanges = true;

          // CALDIAL1 e CALCAPX1
          if (calib.dd) {
            const ddValues = calib.dd.split('$').filter(v => v);
            ddValues.forEach((val, idx) => {
              if (val && val !== '0.0') {
                commandsToSend.push({
                  cmd: 'CALDIAL1',
                  params: { 0: String(idx + 1), 1: String(val) },
                  label: `CALDIAL1 Ponto ${idx + 1}`
                });
              }
            });
          }

          if (calib.cp) {
            const cpValues = calib.cp.split('$').filter(v => v);
            cpValues.forEach((val, idx) => {
              if (val && val !== '0.0') {
                commandsToSend.push({
                  cmd: 'CALCAPX1',
                  params: { 0: String(idx + 1), 1: String(val) },
                  label: `CALCAPX1 Ponto ${idx + 1}`
                });
              }
            });
          }

          if (calib.um) {
            const umValues = calib.um.split('$').filter(v => v);
            umValues.slice(0, 4).forEach((val, idx) => {
              if (val && val !== '0.0') {
                commandsToSend.push({
                  cmd: 'CHART1',
                  params: { 0: String(idx + 1), 1: String(val) },
                  label: `CHART1 Coef. ${idx + 1}`
                });
              }
            });
          }

          if (calib.rg1) {
            const rgValues = calib.rg1.split('$').filter(v => v);
            if (rgValues.length >= 2) {
              commandsToSend.push({
                cmd: 'UMIRAN1',
                params: { 0: rgValues[0], 1: rgValues[1] },
                label: 'UMIRAN1 (Faixa OSC1)'
              });
            }
          }

          if (calib.dd2) {
            const ddValues = calib.dd2.split('$').filter(v => v);
            ddValues.forEach((val, idx) => {
              if (val && val !== '0.0') {
                commandsToSend.push({
                  cmd: 'CALDIAL2',
                  params: { 0: String(idx + 1), 1: String(val) },
                  label: `CALDIAL2 Ponto ${idx + 1}`
                });
              }
            });
          }

          if (calib.cp2) {
            const cpValues = calib.cp2.split('$').filter(v => v);
            cpValues.forEach((val, idx) => {
              if (val && val !== '0.0') {
                commandsToSend.push({
                  cmd: 'CALCAPX2',
                  params: { 0: String(idx + 1), 1: String(val) },
                  label: `CALCAPX2 Ponto ${idx + 1}`
                });
              }
            });
          }

          if (calib.um2) {
            const umValues = calib.um2.split('$').filter(v => v);
            umValues.slice(0, 4).forEach((val, idx) => {
              if (val && val !== '0.0') {
                commandsToSend.push({
                  cmd: 'CHART2',
                  params: { 0: String(idx + 1), 1: String(val) },
                  label: `CHART2 Coef. ${idx + 1}`
                });
              }
            });
          }

          if (calib.rg2) {
            const rgValues = calib.rg2.split('$').filter(v => v);
            if (rgValues.length >= 2) {
              commandsToSend.push({
                cmd: 'UMIRAN2',
                params: { 0: rgValues[0], 1: rgValues[1] },
                label: 'UMIRAN2 (Faixa OSC2)'
              });
            }
          }
        }

        // Envia todos os comandos sequencialmente
        addTerminalLog('info', 'SISTEMA', `🚀 Enviando ${commandsToSend.length} comando(s) ao equipamento...`);

        for (const command of commandsToSend) {
          try {
            console.log(`Enviando: ${command.cmd}`, command.params);
            await sendCommand(command.cmd, command.params, true, true); // skipAutoRefresh, skipLoadingToggle
            successCount++;
            console.log(`✅ Comando ${command.cmd} enviado com sucesso`);
            // Delay entre comandos
            await new Promise(resolve => setTimeout(resolve, 300));
          } catch (err) {
            console.error(`❌ Erro ao enviar ${command.cmd}:`, err);
            errorCount++;
            addTerminalLog('error', 'ERRO', `Falha ao enviar ${command.cmd}: ${err.message}`);
          }
        }

        const resultMsg = `✅ Aplicação concluída: ${successCount} comando(s) enviado(s) com sucesso` +
          (errorCount > 0 ? `, ${errorCount} erro(s)` : '');
        setResult(resultMsg);
        addTerminalLog('success', 'SISTEMA', resultMsg);

        if (successCount > 0) {
          // Reinicia o equipamento e recarrega os dados apropriados
          const rebootMsg = `✅ Configurações aplicadas! Reiniciando equipamento...`;
          setResult(rebootMsg);
          addTerminalLog('info', 'SISTEMA', rebootMsg);
          
          await waitForRebootAndReload(hasConfigChanges, hasCalibChanges);
          
          const finalMsg = `✅ Processo concluído! Configuração carregada e aplicada com sucesso.`;
          setResult(finalMsg);
          addTerminalLog('success', 'SISTEMA', finalMsg);
          
          // Volta para a categoria Operação / Leitura
          setActiveCategory('operacao');
          addTerminalLog('info', 'SISTEMA', '📂 Categoria alterada para: Operação / Leitura');
        } else {
          const warnMsg = `⚠️ Nenhum comando foi enviado com sucesso.`;
          setError(warnMsg);
          addTerminalLog('warning', 'AVISO', warnMsg);
        }
    } catch (err) {
      const errorMsg = '❌ Erro ao aplicar configuração: ' + err.message;
      setError(errorMsg);
      addTerminalLog('error', 'ERRO', errorMsg);
    } finally {
      setLoading(false);
    }
  };

  // Ver detalhes da configuração
  const handleViewConfig = async (config) => {
    setViewConfigData(config);
    setShowViewConfigModal(true);
  };

  // Abrir modal de confirmação de exclusão
  const handleDeleteConfig = (config) => {
    setDeleteConfigData(config);
    setShowDeleteConfigModal(true);
  };

  // Confirmar exclusão
  const confirmDeleteConfig = async () => {
    if (!deleteConfigData) return;

    try {
      setDeletingConfig(true);
      addTerminalLog('info', 'SISTEMA', `🗑️ Excluindo configuração ID: ${deleteConfigData._id || deleteConfigData.id}...`);

      const configId = deleteConfigData._id || deleteConfigData.id;
      const response = await ApiGServer.delete(`/config-equipment/v1/delete/${configId}`);

      if (response.status === 200 || response.status === 204) {
        const successMsg = '✅ Configuração excluída com sucesso!';
        setResult(successMsg);
        addTerminalLog('success', 'SISTEMA', successMsg);

        // Atualiza a lista removendo o item excluído
        setSavedConfigs(prev => prev.filter(c => (c._id || c.id) !== configId));

        setShowDeleteConfigModal(false);
        setDeleteConfigData(null);

        // Se a lista ficou vazia, fecha o modal de lista
        if (savedConfigs.length === 1) {
          setShowLoadConfigModal(false);
        }
      } else {
        throw new Error('Erro ao excluir configuração');
      }
    } catch (err) {
      const errorMsg = '❌ Erro ao excluir configuração: ' + err.message;
      setError(errorMsg);
      addTerminalLog('error', 'ERRO', errorMsg);
    } finally {
      setDeletingConfig(false);
    }
  };

  const waitForRebootAndReload = async (shouldReloadConfig = true, shouldReloadCalib = true) => {
    try {
      addTerminalLog('info', 'SISTEMA', '🔄 Enviando comando de reboot...');
      // Envia comando de reboot (com skipLoadingToggle para não desativar o loader)
      await sendCommand('RBOOT', {}, true, true); // skipAutoRefresh=true, skipLoadingToggle=true

      addTerminalLog('info', 'SISTEMA', '⏳ Aguardando equipamento reiniciar... (até 30 segundos)');
      // Aguarda 3 segundos para o equipamento começar a reiniciar
      await new Promise(resolve => setTimeout(resolve, 3000));

      // Polling para verificar se reiniciou (máximo 30 segundos)
      const maxAttempts = 15; // 15 tentativas x 2 segundos = 30 segundos
      let attempts = 0;
      let rebooted = false;

      while (attempts < maxAttempts && !rebooted) {
        try {
          const response = await ApiTcpServer.get(`/api/equipamento/status/${serialFromUrl}`);
          // Resposta pode conter: { serial, rebooted, sts, err, lastUpdate }
          // Alguns campos podem não existir em alguns momentos
          if (response.data) {
            const { rebooted: isRebooted, sts, err } = response.data;

            /* Status possíveis (sts):
             * 0=START (inicializado), 1=ABRE_TAMPA, 2=FECHA_TAMPA, 3=LEITURA_VAZIO,
             * 4=INICIA_DOSAGEM, 5=MONITORA_NIVEL, 6=DESLIGA_ROSCA, 7=LEITURA_CHEIO,
             * 96=LIBERADO_CONFIG (aceita comandos), 97=NEEDS_REBOOT (precisa reiniciar), 98=STANDBY, 99=WAKEUP
             * 
             * Erros possíveis (err): 0-8 (ver definições no firmware)
             */

            // Considera reiniciado se:
            // 1. Flag explícito rebooted === true OU
            // 2. Está inicializado (sts === 0) sem erros OU
            // 3. Está liberado para configuração (sts === 96) aceitando comandos OU
            // 4. Está em estado operacional (sts >= 4) sem erros
            if (isRebooted === true ||
              (typeof sts === 'number' && err === 0 && (sts === 0 || sts === 96 || sts >= 4))) {
              rebooted = true;
              console.log('✅ Equipamento reiniciado com sucesso:', response.data);
              addTerminalLog('success', 'SISTEMA', '✅ Equipamento reiniciado com sucesso!');
              break;
            } else {
              console.log(`🔄 Tentativa ${attempts + 1}/${maxAttempts} - sts=${sts}, err=${err}, rebooted=${isRebooted}`);
              if (attempts % 3 === 0) {
                addTerminalLog('info', 'SISTEMA', `🔄 Verificando status... (tentativa ${attempts + 1}/${maxAttempts})`);
              }
            }
          }
        } catch (err) {
          console.log(`⏳ Aguardando reboot... (tentativa ${attempts + 1}/${maxAttempts})`);
        }

        attempts++;
        if (!rebooted) {
          await new Promise(resolve => setTimeout(resolve, 2000));
        }
      }

      if (rebooted) {
        // await new Promise(resolve => setTimeout(resolve, 10000));

        // Recarrega apenas os dados relevantes baseado no tipo de alteração
        const startMsg = '✅ Iniciando equipamento, aguarde um momento...';
        setResult(startMsg);
        addTerminalLog('success', 'SISTEMA', startMsg);

        if (shouldReloadConfig) {
          // await sendCommand('RETCONFIG', {}, false, true); // skipAutoRefresh=false, skipLoadingToggle=true
          // await new Promise(resolve => setTimeout(resolve, 3000));
        }

        if (shouldReloadCalib) {
          // await sendCommand('RETCALIB', {}, false, true); // skipAutoRefresh=false, skipLoadingToggle=true
        }

      } else {
        const timeoutMsg = '⚠️ Timeout: Não foi possível confirmar o reboot do equipamento.';
        setError(timeoutMsg);
        addTerminalLog('error', 'ERRO', timeoutMsg);
      }
    } catch (err) {
      console.error('Erro no processo de reboot:', err);
      const errorMsg = 'Erro ao reiniciar equipamento: ' + err.message;
      setError(errorMsg);
      addTerminalLog('error', 'ERRO', errorMsg);
    }
  };

  const handleParamChange = (idx, value) => {
    // Tratamento especial para NSERIE: sempre 5 dígitos, permitindo zeros à esquerda
    const currentCmd = (typeof modalCmdObj?.cmd === 'string' && modalCmdObj.cmd) || selectedCmd;

    if (currentCmd === 'NSERIE' && idx === 0) {
      let onlyDigits = String(value).replace(/\D/g, '');
      if (onlyDigits.length > 5) {
        onlyDigits = onlyDigits.slice(0, 5);
      }
      setParamValues((prev) => ({ ...prev, [idx]: onlyDigits }));
      return;
    }

    setParamValues((prev) => ({ ...prev, [idx]: value }));
  };

  const handleParamSubmit = async (e) => {
    e.preventDefault();
    if (!modalCmdObj) {
      return;
    }

    // Verifica se equipamento está em Standby
    if (!isInStandby) {
      const errorMsg = 'Comandos bloqueados. Aguarde o equipamento entrar em Standby.';
      setError(errorMsg);
      addTerminalLog('warning', 'AVISO', errorMsg);
      return;
    }

    const cmdKey = modalCmdObj.cmd || selectedCmd;

    // Verifica se há pelo menos um valor preenchido
    const hasAnyValue = Object.values(paramValues).some(v => v && String(v).trim() !== '');
    if (!hasAnyValue) {
      setError('Preencha pelo menos um campo antes de salvar.');
      return;
    }

    // Tratamento especial para comandos de calibração com 10 pontos
    if (['CALDIAL1', 'CALCAPX1', 'CALDIAL2', 'CALCAPX2'].includes(cmdKey)) {
      setLoading(true);
      let successCount = 0;
      let errorCount = 0;

      try {
        for (let i = 0; i < 10; i++) {
          const value = paramValues[i];
          if (value && String(value).trim() !== '') {
            try {
              await sendCommand(cmdKey, { 0: String(i + 1), 1: String(value) }, true); // skipAutoRefresh - aguarda resposta do servidor
              successCount++;
            } catch (err) {
              errorCount++;
            }
          }
        }

        setResult(`${cmdKey}: ${successCount} pontos salvos, ${errorCount} erros`);
        setShowParamModal(false);
        setParamValues({});

        // Reinicia equipamento e recarrega dados
        if (successCount > 0) {
          await waitForRebootAndReload();
        }
      } catch (error) {
        setError('Erro ao enviar calibração: ' + error.message);
      } finally {
        setLoading(false);
      }
      return;
    }

    // Tratamento especial para comandos CHART com 4 coeficientes - salva localmente
    if (['CHART1', 'CHART2'].includes(cmdKey)) {
      let changesCount = 0;

      for (let i = 0; i < 4; i++) {
        const value = paramValues[i];
        if (value && String(value).trim() !== '') {
          const changeKey = `${cmdKey}_${i + 1}`;
          setPendingChanges(prev => ({
            ...prev,
            [changeKey]: {
              cmd: cmdKey,
              params: { 0: String(i + 1), 1: String(value) },
              label: `${cmdKey} Coef. ${i + 1}`,
              timestamp: Date.now()
            }
          }));
          changesCount++;
        }
      }

      setShowParamModal(false);
      setParamValues({});

      if (changesCount === 0) {
        setResult('Nenhum coeficiente preenchido.');
      } else {
        setResult(`✓ ${changesCount} coeficientes de ${cmdKey} adicionados. Clique em "Salvar Todas as Alterações" para aplicar.`);
      }
      return;
    }

    // Lógica original para comandos normais
    const labels = modalCmdObj.paramLabels || [];
    const paramsCount = modalCmdObj.params || 0;
    const rules = paramValidation[cmdKey];

    for (let idx = 0; idx < paramsCount; idx += 1) {
      const raw = paramValues[idx] != null ? String(paramValues[idx]).trim() : '';
      const label = labels[idx] || `Parâmetro ${idx + 1}`;

      if (!raw) {
        setError(`Preencha o campo "${label}".`);
        return;
      }

      const rule = Array.isArray(rules) ? rules[idx] : undefined;

      // NSERIE: exige exatamente 5 dígitos
      if (cmdKey === 'NSERIE' && idx === 0) {
        if (!/^\d{5}$/.test(raw)) {
          setError('Número de série deve ter exatamente 5 dígitos (00000 a 99999).');
          return;
        }
      }

      // Se existir regra específica para o comando, aplica tipo e faixa
      if (rule) {
        let valNum;

        if (rule.type === 'int') {
          if (!/^[-+]?\d+$/.test(raw)) {
            setError(`Valor inválido para "${label}". Use apenas números inteiros.`);
            return;
          }
          valNum = parseInt(raw, 10);
        } else if (rule.type === 'float') {
          valNum = parseFloat(raw.replace(',', '.'));
          if (Number.isNaN(valNum)) {
            setError(`Valor inválido para "${label}". Use um número válido.`);
            return;
          }
        }

        if (typeof valNum === 'number') {
          const { min, max, exclusive, upperExclusive } = rule;

          if (exclusive) {
            if (!(valNum > min && valNum < max)) {
              setError(`Valor fora do intervalo permitido para "${label}". Use valor entre ${min} e ${max} (exclusivo).`);
              return;
            }
          } else if (upperExclusive) {
            if (!(valNum >= min && valNum < max)) {
              setError(`Valor fora do intervalo permitido para "${label}". Use valor entre ${min} (incl.) e menor que ${max}.`);
              return;
            }
          } else {
            if (!(valNum >= min && valNum <= max)) {
              setError(`Valor fora do intervalo permitido para "${label}". Use valor entre ${min} e ${max}.`);
              return;
            }
          }
        }
      } else {
        // Fallback genérico: exige valor numérico quando não houver regra explícita
        if (Number.isNaN(Number(raw))) {
          setError(`Valor inválido para "${label}". Use apenas números.`);
          return;
        }
      }
    }

    // Normaliza valores (trim) antes de enviar
    const cleanedParams = {};
    Object.keys(paramValues).forEach((key) => {
      let v = String(paramValues[key]).trim();

      // Para NSERIE, sempre envia com 5 dígitos (zero à esquerda)
      if (cmdKey === 'NSERIE' && Number(key) === 0) {
        v = v.replace(/\D/g, '');
        if (v.length > 5) v = v.slice(0, 5);
        while (v.length < 5) v = `0${v}`;
      }

      cleanedParams[key] = v;
    });

    setError('');

    // Ao invés de enviar o comando imediatamente, acumula as alterações pendentes
    setPendingChanges(prev => ({
      ...prev,
      [selectedCmd]: {
        cmd: selectedCmd,
        params: cleanedParams,
        label: modalCmdObj?.label || selectedCmd,
        timestamp: Date.now()
      }
    }));

    // Fecha o modal e limpa os valores
    setShowParamModal(false);
    setParamValues({});

    // Mostra mensagem de sucesso
    setResult(`✓ Alteração de ${modalCmdObj?.label || selectedCmd} adicionada. Clique em "Salvar Todas as Alterações" para aplicar.`);
  };

  const handleTampa = async (estado) => {
    // estado: 1 = abre, 0 = fecha
    await sendCommand('TAMPA', { 0: String(estado) });
  };

  const handleBatchSave = async () => {
    setLoading(true);
    let successCount = 0;
    let errorCount = 0;

    for (const [cmd, value] of Object.entries(batchParams)) {
      if (value !== '' && value !== null && value !== undefined) {
        try {
          await sendCommand(cmd, { 0: String(value) }, true); // skipAutoRefresh - aguarda resposta do servidor
          successCount++;
        } catch (err) {
          errorCount++;
        }
      }
    }

    setLoading(false);
    setShowBatchModal(false);
    setBatchParams({});
    setResult(`Configuração em lote concluída: ${successCount} sucesso, ${errorCount} erros`);

    // Reinicia equipamento e recarrega dados
    if (successCount > 0) {
      await waitForRebootAndReload();
    }
  };

  // Nova função para salvar todas as alterações pendentes em lote
  const handleSaveAllPendingChanges = () => {
    if (Object.keys(pendingChanges).length === 0) {
      setError('Nenhuma alteração pendente para salvar.');
      return;
    }

    // Abre modal de confirmação
    setShowBatchSaveConfirmModal(true);
  };

  // Função que realmente executa o salvamento após confirmação
  const confirmBatchSave = async () => {
    setShowBatchSaveConfirmModal(false);

    setIsSavingBatch(true);
    setLoading(true);
    let successCount = 0;
    let errorCount = 0;

    addTerminalLog('info', 'SISTEMA', `🚀 Iniciando salvamento em lote de ${Object.keys(pendingChanges).length} alterações...`);

    // Comandos de configuração
    const configurationCommands = ['NSERIE', 'TPFIM', 'TPSTAB', 'TDOSAN', 'RETST', 'DLNEWSTRT', 'TABERT',
      'FTAMPA', 'FTAMPF', 'TOUTTA', 'TOUTTF', 'TOUTS2', 'LIMADA', 'LIMADF',
      'FRQVZ1', 'RANGE1', 'MMOVEL1', 'OFFSET1',
      'FRQVZ2', 'RANGE2', 'MMOVEL2', 'OFFSET2', 'TAMPA'];

    // Detecta quais tipos de comandos foram alterados
    let hasConfigChanges = false;
    let hasCalibChanges = false;

    for (const [key, change] of Object.entries(pendingChanges)) {
      if (configurationCommands.includes(change.cmd)) {
        hasConfigChanges = true;
      } else if (calibrationCommands.includes(change.cmd) ||
        change.cmd.startsWith('CALDIAL') ||
        change.cmd.startsWith('CALCAPX') ||
        change.cmd.startsWith('CHART')) {
        hasCalibChanges = true;
      }
    }

    try {
      // Envia todas as alterações pendentes sequencialmente
      for (const [key, change] of Object.entries(pendingChanges)) {
        try {
          console.log(`Enviando: ${change.cmd}`, change.params);
          // Aguarda a resposta completa do comando antes de prosseguir
          await sendCommand(change.cmd, change.params, true, true); // skipAutoRefresh, skipLoadingToggle
          successCount++;
          console.log(`✅ Comando ${change.cmd} enviado com sucesso`);
          // Delay entre comandos para não sobrecarregar o equipamento
          await new Promise(resolve => setTimeout(resolve, 300));
        } catch (err) {
          console.error(`❌ Erro ao enviar ${change.cmd}:`, err);
          errorCount++;
          addTerminalLog('error', 'ERRO', `Falha ao enviar ${change.cmd}: ${err.message}`);
          // Continua mesmo em caso de erro para tentar enviar os demais comandos
        }
      }

      const resultMsg = `✅ Salvamento concluído: ${successCount} comando(s) enviado(s) com sucesso` +
        (errorCount > 0 ? `, ${errorCount} erro(s)` : '');
      setResult(resultMsg);
      addTerminalLog('success', 'SISTEMA', resultMsg);

      // Limpa as alterações pendentes após salvar com sucesso
      if (successCount > 0) {
        setPendingChanges({});

        // Reinicia o equipamento e recarrega os dados apropriados
        const rebootMsg = `✅ Configurações salvas! Reiniciando equipamento...`;
        setResult(rebootMsg);
        addTerminalLog('info', 'SISTEMA', rebootMsg);
        // Aguarda completamente o processo de reboot antes de liberar
        await waitForRebootAndReload(hasConfigChanges, hasCalibChanges);
        
        const finalMsg = `✅ Processo concluído! ${successCount} comando(s) enviado(s) com sucesso.`;
        setResult(finalMsg);
        addTerminalLog('success', 'SISTEMA', finalMsg);
        
        // Volta para a categoria Operação / Leitura
        setActiveCategory('operacao');
        addTerminalLog('info', 'SISTEMA', '📂 Categoria alterada para: Operação / Leitura');
      } else {
        const warnMsg = `⚠️ Nenhum comando foi enviado com sucesso.`;
        setError(warnMsg);
        addTerminalLog('warning', 'AVISO', warnMsg);
      }
    } catch (err) {
      const errorMsg = 'Erro ao processar alterações em lote: ' + err.message;
      setError(errorMsg);
      addTerminalLog('error', 'ERRO', errorMsg);
    } finally {
      // Sempre libera os botões no final, independente do resultado
      setIsSavingBatch(false);
      setLoading(false);
    }
  };

  // Função para limpar todas as alterações pendentes
  const handleClearPendingChanges = () => {
    setShowDiscardChangesModal(true);
  };

  const confirmDiscardChanges = () => {
    const count = Object.keys(pendingChanges).length;
    setPendingChanges({});
    const discardMsg = `❌ ${count} alterações pendentes descartadas.`;
    setResult(discardMsg);
    addTerminalLog('warning', 'SISTEMA', discardMsg);
    setShowDiscardChangesModal(false);
  };

  const handleDialCapxModalOpen = () => {
    console.log('handleDialCapxModalOpen - retCalib:', retCalib);

    // Primeiro, tenta carregar valores pendentes
    const table = Array(10).fill().map((_, i) => {
      const caldialKey = `CALDIAL1_${i + 1}`;
      const calcapxKey = `CALCAPX1_${i + 1}`;

      return {
        idx: i + 1,
        caldial: pendingChanges[caldialKey]?.params[1] || '',
        calcapx: pendingChanges[calcapxKey]?.params[1] || ''
      };
    });

    // Se não há valores pendentes, carrega valores atuais do equipamento
    if (retCalib && table.every(row => !row.caldial && !row.calcapx)) {
      const ddValues = retCalib.dd ? retCalib.dd.split('$').filter(v => v) : [];
      const cpValues = retCalib.cp ? retCalib.cp.split('$').filter(v => v) : [];
      console.log('DIAL1/CAPX1 - ddValues:', ddValues, 'cpValues:', cpValues);

      const tableFromDevice = Array(10).fill().map((_, i) => ({
        idx: i + 1,
        caldial: ddValues[i] || '',
        calcapx: cpValues[i] || ''
      }));
      setDialCapxTable(tableFromDevice);
      setOriginalDialCapxTable(JSON.parse(JSON.stringify(tableFromDevice)));
    } else {
      // Usa valores pendentes ou vazios
      setDialCapxTable(table);
      // Para os valores originais, ainda usa os do equipamento
      if (retCalib) {
        const ddValues = retCalib.dd ? retCalib.dd.split('$').filter(v => v) : [];
        const cpValues = retCalib.cp ? retCalib.cp.split('$').filter(v => v) : [];
        const originalTable = Array(10).fill().map((_, i) => ({
          idx: i + 1,
          caldial: ddValues[i] || '',
          calcapx: cpValues[i] || ''
        }));
        setOriginalDialCapxTable(JSON.parse(JSON.stringify(originalTable)));
      } else {
        const emptyOriginal = Array(10).fill().map((_, i) => ({ idx: i + 1, caldial: '', calcapx: '' }));
        setOriginalDialCapxTable(JSON.parse(JSON.stringify(emptyOriginal)));
      }
    }

    setShowDialCapxModal(true);
  };

  const handleDialCapx1Save = () => {
    let changesCount = 0;

    // Acumula alterações de CALDIAL1 (salva todos os campos preenchidos)
    for (const row of dialCapxTable) {
      if (row.caldial !== '' && row.caldial !== null) {
        const changeKey = `CALDIAL1_${row.idx}`;
        setPendingChanges(prev => ({
          ...prev,
          [changeKey]: {
            cmd: 'CALDIAL1',
            params: { 0: String(row.idx), 1: String(row.caldial) },
            label: `CALDIAL1 Ponto ${row.idx}`,
            timestamp: Date.now()
          }
        }));
        changesCount++;
      }
    }

    // Acumula alterações de CALCAPX1 (salva todos os campos preenchidos)
    for (const row of dialCapxTable) {
      if (row.calcapx !== '' && row.calcapx !== null) {
        const changeKey = `CALCAPX1_${row.idx}`;
        setPendingChanges(prev => ({
          ...prev,
          [changeKey]: {
            cmd: 'CALCAPX1',
            params: { 0: String(row.idx), 1: String(row.calcapx) },
            label: `CALCAPX1 Ponto ${row.idx}`,
            timestamp: Date.now()
          }
        }));
        changesCount++;
      }
    }

    setShowDialCapxModal(false);

    if (changesCount === 0) {
      setResult('Nenhuma alteração detectada.');
    } else {
      setResult(`✓ ${changesCount} alterações de DIAL1/CAPX1 adicionadas. Clique em "Salvar Todas as Alterações" para aplicar.`);
    }
  };

  const handleDialCapx2ModalOpen = () => {
    console.log('handleDialCapx2ModalOpen - retCalib:', retCalib);

    // Primeiro, tenta carregar valores pendentes
    const table = Array(10).fill().map((_, i) => {
      const caldialKey = `CALDIAL2_${i + 1}`;
      const calcapxKey = `CALCAPX2_${i + 1}`;

      return {
        idx: i + 1,
        caldial: pendingChanges[caldialKey]?.params[1] || '',
        calcapx: pendingChanges[calcapxKey]?.params[1] || ''
      };
    });

    // Se não há valores pendentes, carrega valores atuais do equipamento
    if (retCalib && table.every(row => !row.caldial && !row.calcapx)) {
      const ddValues = retCalib.dd2 ? retCalib.dd2.split('$').filter(v => v) : [];
      const cpValues = retCalib.cp2 ? retCalib.cp2.split('$').filter(v => v) : [];
      console.log('DIAL2/CAPX2 - ddValues:', ddValues, 'cpValues:', cpValues);

      const tableFromDevice = Array(10).fill().map((_, i) => ({
        idx: i + 1,
        caldial: ddValues[i] || '',
        calcapx: cpValues[i] || ''
      }));
      setDialCapx2Table(tableFromDevice);
      setOriginalDialCapx2Table(JSON.parse(JSON.stringify(tableFromDevice)));
    } else {
      // Usa valores pendentes ou vazios
      setDialCapx2Table(table);
      // Para os valores originais, ainda usa os do equipamento
      if (retCalib) {
        const ddValues = retCalib.dd2 ? retCalib.dd2.split('$').filter(v => v) : [];
        const cpValues = retCalib.cp2 ? retCalib.cp2.split('$').filter(v => v) : [];
        const originalTable = Array(10).fill().map((_, i) => ({
          idx: i + 1,
          caldial: ddValues[i] || '',
          calcapx: cpValues[i] || ''
        }));
        setOriginalDialCapx2Table(JSON.parse(JSON.stringify(originalTable)));
      } else {
        const emptyOriginal = Array(10).fill().map((_, i) => ({ idx: i + 1, caldial: '', calcapx: '' }));
        setOriginalDialCapx2Table(JSON.parse(JSON.stringify(emptyOriginal)));
      }
    }

    setShowDialCapx2Modal(true);
  };

  const handleDialCapx2Save = () => {
    let changesCount = 0;

    // Acumula alterações de CALDIAL2 (salva todos os campos preenchidos)
    for (const row of dialCapx2Table) {
      if (row.caldial !== '' && row.caldial !== null) {
        const changeKey = `CALDIAL2_${row.idx}`;
        setPendingChanges(prev => ({
          ...prev,
          [changeKey]: {
            cmd: 'CALDIAL2',
            params: { 0: String(row.idx), 1: String(row.caldial) },
            label: `CALDIAL2 Ponto ${row.idx}`,
            timestamp: Date.now()
          }
        }));
        changesCount++;
      }
    }

    // Acumula alterações de CALCAPX2 (salva todos os campos preenchidos)
    for (const row of dialCapx2Table) {
      if (row.calcapx !== '' && row.calcapx !== null) {
        const changeKey = `CALCAPX2_${row.idx}`;
        setPendingChanges(prev => ({
          ...prev,
          [changeKey]: {
            cmd: 'CALCAPX2',
            params: { 0: String(row.idx), 1: String(row.calcapx) },
            label: `CALCAPX2 Ponto ${row.idx}`,
            timestamp: Date.now()
          }
        }));
        changesCount++;
      }
    }

    setShowDialCapx2Modal(false);

    if (changesCount === 0) {
      setResult('Nenhuma alteração detectada.');
    } else {
      setResult(`✓ ${changesCount} alterações de DIAL2/CAPX2 adicionadas. Clique em "Salvar Todas as Alterações" para aplicar.`);
    }
  };

  const handleCalibSave = () => {
    const suffix = calibOsc === '2' ? '2' : '';
    let changesCount = 0;

    // Acumula alterações de CALDIAL (salva todos os campos preenchidos)
    for (const row of calibTable) {
      if (row.caldial !== '' && row.caldial !== null) {
        const changeKey = `CALDIAL${suffix}_${row.idx}`;
        setPendingChanges(prev => ({
          ...prev,
          [changeKey]: {
            cmd: 'CALDIAL' + suffix,
            params: { 0: String(row.idx), 1: String(row.caldial) },
            label: `CALDIAL${suffix} Ponto ${row.idx}`,
            timestamp: Date.now()
          }
        }));
        changesCount++;
      }
    }

    // Acumula alterações de CALCAPX (salva todos os campos preenchidos)
    for (const row of calibTable) {
      if (row.calcapx !== '' && row.calcapx !== null) {
        const changeKey = `CALCAPX${suffix}_${row.idx}`;
        setPendingChanges(prev => ({
          ...prev,
          [changeKey]: {
            cmd: 'CALCAPX' + suffix,
            params: { 0: String(row.idx), 1: String(row.calcapx) },
            label: `CALCAPX${suffix} Ponto ${row.idx}`,
            timestamp: Date.now()
          }
        }));
        changesCount++;
      }
    }

    // Acumula alterações de CHART (apenas primeiras 4 linhas, salva todos os campos preenchidos)
    for (const row of calibTable.slice(0, 4)) {
      if (row.chart !== '' && row.chart !== null) {
        const changeKey = `CHART${suffix}_${row.idx}`;
        setPendingChanges(prev => ({
          ...prev,
          [changeKey]: {
            cmd: 'CHART' + suffix,
            params: { 0: String(row.idx), 1: String(row.chart) },
            label: `CHART${suffix} Coef. ${row.idx}`,
            timestamp: Date.now()
          }
        }));
        changesCount++;
      }
    }

    setShowCalibModal(false);

    if (changesCount === 0) {
      setResult('Nenhuma alteração detectada.');
    } else {
      setResult(`✓ ${changesCount} alterações de calibração adicionadas. Clique em "Salvar Todas as Alterações" para aplicar.`);
    }
  };

  const getButtonLabel = (cmdObj) => {
    const configKey = cmdToConfigMap[cmdObj.cmd];
    const hasValue = retConfig && configKey && retConfig[configKey] !== undefined;
    const hasPendingChange = pendingChanges[cmdObj.cmd];

    // Se há alteração pendente, mostra o novo valor
    if (hasPendingChange) {
      const labelBase = cmdObj.label.split('(')[0].trim();
      const newValue = hasPendingChange.params[0];
      return `${labelBase}\n[Novo: ${newValue}]`;
    }

    // Senão, mostra o valor atual
    if (hasValue) {
      const valor = retConfig[configKey];
      const labelBase = cmdObj.label.split('(')[0].trim();
      return `${labelBase}\n[${valor}]`;
    }

    return cmdObj.label;
  };

  // Função para contar alterações pendentes de calibração
  const getPendingCalibrationCount = (baseCmd) => {
    return Object.keys(pendingChanges).filter(key => key.startsWith(baseCmd)).length;
  };

  // Agrupamento visual dos comandos por tipo
  const filtered = comandos.filter(c => {
    // TAMPA terá controles dedicados (Abrir/Fechar), então é removido da lista genérica
    if (c.cmd === 'TAMPA') return false;
    if (searchTerm) {
      const text = `${c.cmd} ${c.label}`.toLowerCase();
      return text.includes(searchTerm.toLowerCase());
    }
    return true;
  });

  // Define todas as categorias com seus filtros
  const allGrupos = useMemo(() => [
    {
      id: 'operacao',
      nome: 'Operação / Leitura',
      icon: '📊',
      color: 'var(--success-color, #198754)',
      comandos: filtered.filter(c => c.params === 0 && !criticalCommands.includes(c.cmd) && c.cmd !== 'RETCONFIG' && c.cmd !== 'RETCALIB' && c.cmd !== 'ROSCON' && c.cmd !== 'ROSCOF' && c.cmd !== 'TAMPA')
    },
    {
      id: 'configuracao',
      nome: 'Configuração',
      icon: '⚙️',
      color: 'var(--warning-color, #ffc107)',
      comandos: filtered.filter(c => c.params > 0 && !calibrationCommands.includes(c.cmd))
    },
    {
      id: 'calibracao',
      nome: 'Calibração',
      icon: '🎯',
      color: 'var(--brand-light-green, #8fad15)',
      comandos: filtered.filter(
        c =>
          calibrationCommands.includes(c.cmd) &&
          c.cmd !== 'CALDIAL1' &&
          c.cmd !== 'CALCAPX1' &&
          c.cmd !== 'CALDIAL2' &&
          c.cmd !== 'CALCAPX2' &&
          c.cmd !== 'CHART1' &&
          c.cmd !== 'CHART2' &&
          c.cmd !== 'UMIRAN1' &&
          c.cmd !== 'UMIRAN2'
      )
    },
    {
      id: 'sistema',
      nome: 'Sistema (Crítico)',
      icon: '⚠️',
      color: 'var(--danger-color, #dc3545)',
      comandos: filtered.filter(c => criticalCommands.includes(c.cmd))
    },
    {
      id: 'ferramentas',
      nome: 'Ferramentas',
      icon: '🛠️',
      color: 'var(--text-muted, #6c757d)',
      comandos: [] // Categoria especial sem comandos diretos
    }
  ], [filtered]);

  // Filtra grupos baseado na categoria ativa
  const grupos = useMemo(() => {
    if (activeCategory === 'ferramentas') {
      return [allGrupos.find(g => g.id === 'ferramentas')];
    }
    return allGrupos.filter(g => g.id === activeCategory && (g.comandos.length > 0 || g.id === 'calibracao'));
  }, [activeCategory, allGrupos]);

  // Renderiza card de status sempre fixo, apenas o conteúdo muda
  const renderStatusCard = () => {
    // Quando sts === 96 (liberado para configuração), deixa o card mais apagado
    const isConfigMode = realtimeData?.sts === 96;

    return (
      <Card style={{
        background: isConfigMode
          ? 'linear-gradient(135deg, #475569 0%, #334155 100%)'
          : 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
        border: socketConnected ? '2px solid rgba(34, 197, 94, 0.3)' : '2px solid rgba(239, 68, 68, 0.3)',
        borderRadius: '8px',
        boxShadow: socketConnected ? '0 4px 12px rgba(34, 197, 94, 0.15)' : '0 4px 12px rgba(239, 68, 68, 0.15)',
        transition: 'all 0.3s ease',
        opacity: isConfigMode ? 0.75 : 1,
        height: '100%',
        overflowY: 'auto',
        maxHeight: '500px',
        willChange: 'border, box-shadow'
      }}>
        <Card.Body className="p-3">
          <Row className="align-items-stretch g-3">
            {/* Indicador de Conexão */}
            <Col xs={12} md={4}>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                padding: '8px 12px',
                background: socketConnected ? 'rgba(34, 197, 94, 0.1)' : 'rgba(239, 68, 68, 0.1)',
                borderRadius: '8px',
                border: socketConnected ? '1px solid rgba(34, 197, 94, 0.2)' : '1px solid rgba(239, 68, 68, 0.2)',
                transition: 'background 0.3s ease, border 0.3s ease',
                minHeight: '85px',
                height: '100%'
              }}>
                <div style={{ color: '#94a3b8', fontSize: '0.7rem', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                  Conexão
                </div>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  flex: 1
                }}>
                  <span style={{
                    width: '12px',
                    height: '12px',
                    borderRadius: '50%',
                    background: socketConnected ? '#22c55e' : '#ef4444',
                    boxShadow: socketConnected ? '0 0 12px #22c55e' : '0 0 12px #ef4444',
                    animation: socketConnected ? 'pulse 2s infinite' : 'none',
                    flexShrink: 0,
                    transition: 'background 0.3s ease, box-shadow 0.3s ease'
                  }} />
                  <div style={{ flex: 1 }}>
                    <div style={{
                      color: socketConnected ? '#22c55e' : '#ef4444',
                      fontSize: '0.95rem',
                      fontWeight: 600,
                      letterSpacing: '0.5px',
                      transition: 'color 0.3s ease'
                    }}>
                      {socketConnected ? 'ONLINE' : 'OFFLINE'}
                    </div>
                    <div style={{ color: '#64748b', fontSize: '0.7rem', marginTop: '2px' }}>
                      Tempo Real
                    </div>
                  </div>
                </div>
              </div>
            </Col>

            {/* Status Operacional */}
            <Col xs={12} md={4}>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                padding: '8px 12px',
                background: 'rgba(143, 173, 21, 0.1)',
                borderRadius: '8px',
                border: '1px solid rgba(143, 173, 21, 0.2)',
                minHeight: '85px',
                height: '100%'
              }}>
                <div style={{ color: '#94a3b8', fontSize: '0.7rem', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                  Status Operacional
                </div>
                <div key={`status-${realtimeData?.sts}-${realtimeData?.statusMsg}`} style={{
                  color: '#8fad15',
                  fontSize: '0.95rem',
                  fontWeight: 600,
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  opacity: realtimeData?.statusMsg ? 1 : 0.5,
                  flex: 1
                }}>
                  <span style={{ fontSize: '1.2rem' }}>
                    {realtimeData?.sts === 0 ? '🔄' :
                      realtimeData?.sts === 1 ? '🔓' :
                        realtimeData?.sts === 2 ? '🔒' :
                          realtimeData?.sts === 3 ? '📊' :
                            realtimeData?.sts === 4 ? '▶️' :
                              realtimeData?.sts === 5 ? '📈' :
                                realtimeData?.sts === 6 ? '⏸️' :
                                  realtimeData?.sts === 7 ? '✅' :
                                    realtimeData?.sts === 97 ? '🔄' :
                                      realtimeData?.sts === 98 ? '⏳' :
                                        realtimeData?.sts === 99 ? '⚡' : '⏹️'}
                  </span>
                  <span style={{ flex: 1 }}>{realtimeData?.statusMsg || 'Aguardando dados...'}</span>
                </div>
                {realtimeData?.sts !== undefined && (
                  <div style={{ color: '#64748b', fontSize: '0.7rem', marginTop: '4px' }}>
                    Código: STS_{realtimeData.sts}
                  </div>
                )}
              </div>
            </Col>

            {/* Erro */}
            <Col xs={12} md={4}>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                padding: '8px 12px',
                background: (realtimeData?.err || 0) > 0 ? 'rgba(251, 146, 60, 0.1)' : 'rgba(34, 197, 94, 0.1)',
                borderRadius: '8px',
                border: (realtimeData?.err || 0) > 0 ? '1px solid rgba(251, 146, 60, 0.3)' : '1px solid rgba(34, 197, 94, 0.2)',
                transition: 'background 0.3s ease, border 0.3s ease',
                minHeight: '85px',
                height: '100%'
              }}>
                <div style={{ color: '#94a3b8', fontSize: '0.7rem', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                  {(realtimeData?.err || 0) > 0 ? 'Erro Detectado' : 'Sistema OK'}
                </div>
                <div key={`error-${realtimeData?.err}-${realtimeData?.errorMsg}`} style={{
                  color: (realtimeData?.err || 0) > 0 ? '#fb923c' : '#22c55e',
                  fontSize: '0.95rem',
                  fontWeight: 600,
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  flex: 1
                }}>
                  <span style={{ fontSize: '1.2rem' }}>
                    {(realtimeData?.err || 0) > 0 ? '⚠️' : '✅'}
                  </span>
                  <span style={{ flex: 1 }}>
                    {(realtimeData?.err || 0) > 0 && realtimeData?.errorMsg ? realtimeData.errorMsg : 'Sistema OK'}
                  </span>
                </div>
                {(realtimeData?.err || 0) > 0 && (
                  <div style={{ color: '#64748b', fontSize: '0.7rem', marginTop: '4px' }}>
                    Código: ERR_{realtimeData.err}
                  </div>
                )}
              </div>
            </Col>
          </Row>

          {/* Linha de informações adicionais */}
          <Row className="mt-3 pt-3" style={{ borderTop: '1px solid rgba(100, 116, 139, 0.2)' }}>
            <Col xs={4}>
              <div style={{ color: '#64748b', fontSize: '0.7rem', marginBottom: '2px' }}>Serial</div>
              <div style={{ color: '#cbd5e1', fontSize: '0.85rem', fontWeight: 500 }}>
                {realtimeData?.serial || serialFromUrl}
              </div>
            </Col>
            <Col xs={4}>
              <div style={{ color: '#64748b', fontSize: '0.7rem', marginBottom: '2px' }}>Reiniciado</div>
              <div style={{ color: '#cbd5e1', fontSize: '0.85rem', fontWeight: 500 }}>
                {realtimeData?.rebooted ? <span style={{ color: '#22c55e' }}>✓ Sim</span> : <span style={{ color: '#64748b' }}>- Não</span>}
              </div>
            </Col>
            <Col xs={4}>
              <div style={{ color: '#64748b', fontSize: '0.7rem', marginBottom: '2px' }}>Atualizado</div>
              <div key={`time-${realtimeData?.lastUpdate}`} style={{ color: '#cbd5e1', fontSize: '0.85rem', fontWeight: 500 }}>
                {realtimeData?.lastUpdate ? new Date(realtimeData.lastUpdate).toLocaleTimeString('pt-BR') : '-'}
              </div>
            </Col>
          </Row>

          {/* Sensores */}
          {realtimeData?.sns && Array.isArray(realtimeData.sns) && (
            <Row className="mt-3 pt-3" style={{ borderTop: '1px solid rgba(100, 116, 139, 0.2)' }}>
              <Col xs={12}>
                <div style={{ color: '#94a3b8', fontSize: '0.7rem', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                  Sensores
                </div>
                <Row className="g-2">
                  <Col xs={12} md={4}>
                    <div style={{
                      padding: '6px 10px',
                      background: realtimeData.sns[0] === 1 ? 'rgba(34, 197, 94, 0.1)' : 'rgba(100, 116, 139, 0.1)',
                      borderRadius: '6px',
                      border: realtimeData.sns[0] === 1 ? '1px solid rgba(34, 197, 94, 0.3)' : '1px solid rgba(100, 116, 139, 0.2)',
                      transition: 'all 0.3s ease'
                    }}>
                      <div style={{
                        color: realtimeData.sns[0] === 1 ? '#22c55e' : '#64748b',
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px'
                      }}>
                        <span>{realtimeData.sns[0] === 1 ? '🟢' : '⚪'}</span>
                        <span>Rosca de Dosagem</span>
                      </div>
                      <div style={{ color: '#64748b', fontSize: '0.65rem', marginTop: '2px' }}>
                        {realtimeData.sns[0] === 1 ? 'Ativo' : 'Inativo'}
                      </div>
                    </div>
                  </Col>
                  <Col xs={12} md={4}>
                    <div style={{
                      padding: '6px 10px',
                      background: realtimeData.sns[1] === 1 ? 'rgba(34, 197, 94, 0.1)' : 'rgba(100, 116, 139, 0.1)',
                      borderRadius: '6px',
                      border: realtimeData.sns[1] === 1 ? '1px solid rgba(34, 197, 94, 0.3)' : '1px solid rgba(100, 116, 139, 0.2)',
                      transition: 'all 0.3s ease'
                    }}>
                      <div style={{
                        color: realtimeData.sns[1] === 1 ? '#22c55e' : '#64748b',
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px'
                      }}>
                        <span>{realtimeData.sns[1] === 1 ? '🟢' : '⚪'}</span>
                        <span>Embuchamento</span>
                      </div>
                      <div style={{ color: '#64748b', fontSize: '0.65rem', marginTop: '2px' }}>
                        {realtimeData.sns[1] === 1 ? 'Ativo' : 'Inativo'}
                      </div>
                    </div>
                  </Col>
                  <Col xs={12} md={4}>
                    <div style={{
                      padding: '6px 10px',
                      background: realtimeData.sns[2] === 1 ? 'rgba(34, 197, 94, 0.1)' : 'rgba(100, 116, 139, 0.1)',
                      borderRadius: '6px',
                      border: realtimeData.sns[2] === 1 ? '1px solid rgba(34, 197, 94, 0.3)' : '1px solid rgba(100, 116, 139, 0.2)',
                      transition: 'all 0.3s ease'
                    }}>
                      <div style={{
                        color: realtimeData.sns[2] === 1 ? '#22c55e' : '#64748b',
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px'
                      }}>
                        <span>{realtimeData.sns[2] === 1 ? '🟢' : '⚪'}</span>
                        <span>Gatilho Redler</span>
                      </div>
                      <div style={{ color: '#64748b', fontSize: '0.65rem', marginTop: '2px' }}>
                        {realtimeData.sns[2] === 1 ? 'Ativo' : 'Inativo'}
                      </div>
                    </div>
                  </Col>
                  <Col xs={12} md={4}>
                    <div style={{
                      padding: '6px 10px',
                      background: realtimeData.sns[3] === 1 ? 'rgba(34, 197, 94, 0.1)' : 'rgba(100, 116, 139, 0.1)',
                      borderRadius: '6px',
                      border: realtimeData.sns[3] === 1 ? '1px solid rgba(34, 197, 94, 0.3)' : '1px solid rgba(100, 116, 139, 0.2)',
                      transition: 'all 0.3s ease'
                    }}>
                      <div style={{
                        color: realtimeData.sns[3] === 1 ? '#22c55e' : '#64748b',
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px'
                      }}>
                        <span>{realtimeData.sns[3] === 1 ? '🟢' : '⚪'}</span>
                        <span>Falha em Painel</span>
                      </div>
                      <div style={{ color: '#64748b', fontSize: '0.65rem', marginTop: '2px' }}>
                        {realtimeData.sns[3] === 1 ? 'Ativo' : 'Inativo'}
                      </div>
                    </div>
                  </Col>
                  <Col xs={12} md={4}>
                    <div style={{
                      padding: '6px 10px',
                      background: realtimeData.sns[4] === 1 ? 'rgba(34, 197, 94, 0.1)' : 'rgba(100, 116, 139, 0.1)',
                      borderRadius: '6px',
                      border: realtimeData.sns[4] === 1 ? '1px solid rgba(34, 197, 94, 0.3)' : '1px solid rgba(100, 116, 139, 0.2)',
                      transition: 'all 0.3s ease'
                    }}>
                      <div style={{
                        color: realtimeData.sns[4] === 1 ? '#22c55e' : '#64748b',
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px'
                      }}>
                        <span>{realtimeData.sns[4] === 1 ? '🟢' : '⚪'}</span>
                        <span>Motor Rosca</span>
                      </div>
                      <div style={{ color: '#64748b', fontSize: '0.65rem', marginTop: '2px' }}>
                        {realtimeData.sns[4] === 1 ? 'Ativo' : 'Inativo'}
                      </div>
                    </div>
                  </Col>
                  <Col xs={12} md={4}>
                    <div style={{
                      padding: '6px 10px',
                      background: realtimeData.sns[5] === 1 ? 'rgba(34, 197, 94, 0.1)' : 'rgba(100, 116, 139, 0.1)',
                      borderRadius: '6px',
                      border: realtimeData.sns[5] === 1 ? '1px solid rgba(34, 197, 94, 0.3)' : '1px solid rgba(100, 116, 139, 0.2)',
                      transition: 'all 0.3s ease'
                    }}>
                      <div style={{
                        color: realtimeData.sns[5] === 1 ? '#22c55e' : '#64748b',
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px'
                      }}>
                        <span>{realtimeData.sns[5] === 1 ? '🟢' : '⚪'}</span>
                        <span>Motor Descarga</span>
                      </div>
                      <div style={{ color: '#64748b', fontSize: '0.65rem', marginTop: '2px' }}>
                        {realtimeData.sns[5] === 1 ? 'Ativo' : 'Inativo'}
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          )}

          {/* Alerta quando não está liberado para configuração */}
          {realtimeData?.sts !== undefined && realtimeData.sts !== 96 && (
            <Row className="mt-2">
              <Col xs={12}>
                <div style={{
                  padding: '8px 12px',
                  background: 'rgba(251, 191, 36, 0.1)',
                  borderRadius: '8px',
                  border: '1px solid rgba(251, 191, 36, 0.3)',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  <span style={{ fontSize: '1rem' }}>🔒</span>
                  <span style={{ color: '#fbbf24', fontSize: '0.8rem', fontWeight: 500 }}>
                    Comandos bloqueados. Equipamento precisa estar liberado para configuração.
                  </span>
                </div>
              </Col>
            </Row>
          )}
        </Card.Body>
      </Card>
    );
  };

  return (
    <Page className="p-2" title={`Comandos - ${serialFromUrl}`}>
      <Header page={`Comandos - ${serialFromUrl}`} />

      {/* Botão de Voltar */}
      <div className="mb-3">
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={handleGoBack}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            fontWeight: 500,
            padding: '6px 12px'
          }}
        >
          <span style={{ fontSize: '1.1rem' }}>←</span>
          Voltar e Desconectar
        </Button>
      </div>

      {/* Card de Status e Terminal lado a lado */}
      <Row className="g-3 mb-3">
        <Col xs={12} lg={6} style={{ minHeight: '400px', maxHeight: '400px' }}>
          {renderStatusCard()}
        </Col>
        <Col xs={12} lg={6} style={{ minHeight: '400px', maxHeight: '400px' }}>
          <ResponsePanel
            terminalLogs={terminalLogs}
          />
        </Col>
      </Row>

      <Card
        className="p-3 w-100"
        style={{
          minHeight: '60vh',
          borderRadius: '12px',
          background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
          overscrollBehavior: 'contain'
        }}
      >

        {/* Botões de configuração */}
        <ConfigButtons
          loading={loading}
          disabled={!isInStandby}
          sts={realtimeData?.sts}
          onUpdate={handleUpdateConfigAndCalib}
          onSetting={async () => {
            /* if (!isInStandby) {
              setError('Equipamento não está liberado para configuração. Necessário estar no modo "Liberado para configuração".');
              return;
            } */
            setLoading(true);
            setError('');
            try {
              await sendCommand('SETTING');
            } catch (err) {
              setError('Erro ao enviar comando SETTING');
            } finally {
              setLoading(false);
            }
          }}
        />

        <Row className="g-3">{/* Sidebar de categorias */}
          <Col xs={12} lg={3}>
            <CategorySidebar
              allGrupos={allGrupos}
              activeCategory={activeCategory}
              onCategoryChange={handleCategoryChange}
              searchTerm={searchTerm}
              onSearchChange={setSearchTerm}
              disabled={!isInStandby}
            />
          </Col>

          {/* Área de comandos */}
          <Col xs={12} lg={9}>
            {activeCategory === 'ferramentas' ? (
              <div>
                <h6 className="mb-3" style={{ color: 'var(--text-muted, #6c757d)', fontWeight: 600 }}>
                  🛠️ Ferramentas Avançadas
                </h6>

                <Row className="g-3 mb-4">
                  <Col xs={12} md={6} lg={3}>
                    <Card style={{ background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)', border: '1px solid rgba(71, 85, 105, 0.5)', borderRadius: '12px', height: '100%' }}>
                      <Card.Body>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
                          <span style={{ fontSize: '2rem', marginRight: '12px' }}>📥</span>
                          <div>
                            <h6 style={{ margin: 0, color: '#e2e8f0', fontWeight: 600 }}>Exportar JSON</h6>
                            <small style={{ color: '#94a3b8' }}>Baixar em arquivo</small>
                          </div>
                        </div>
                        <Button
                          variant="outline-success"
                          onClick={exportConfigJSON}
                          disabled={loading || (!retConfig && !retCalib) || !isInStandby}
                          style={{ width: '100%', fontWeight: 500 }}
                        >
                          📥 Baixar JSON
                        </Button>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col xs={12} md={6} lg={3}>
                    <Card style={{ background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)', border: '1px solid rgba(71, 85, 105, 0.5)', borderRadius: '12px', height: '100%' }}>
                      <Card.Body>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
                          <span style={{ fontSize: '2rem', marginRight: '12px' }}>📤</span>
                          <div>
                            <h6 style={{ margin: 0, color: '#e2e8f0', fontWeight: 600 }}>Importar JSON</h6>
                            <small style={{ color: '#94a3b8' }}>Carregar de arquivo</small>
                          </div>
                        </div>
                        <input
                          type="file"
                          accept=".json"
                          onChange={handleImportFile}
                          style={{ display: 'none' }}
                          id="import-config-file"
                          disabled={loading || !isInStandby}
                        />
                        <Button
                          variant="outline-primary"
                          onClick={() => document.getElementById('import-config-file').click()}
                          disabled={loading || !isInStandby}
                          style={{ width: '100%', fontWeight: 500 }}
                        >
                          📤 Carregar JSON
                        </Button>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col xs={12} md={6} lg={3}>
                    <Card style={{ background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)', border: '1px solid rgba(143, 173, 21, 0.3)', borderRadius: '12px', height: '100%' }}>
                      <Card.Body>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
                          <span style={{ fontSize: '2rem', marginRight: '12px' }}>💾</span>
                          <div>
                            <h6 style={{ margin: 0, color: '#e2e8f0', fontWeight: 600 }}>Salvar no Banco</h6>
                            <small style={{ color: '#94a3b8' }}>Armazenar no servidor</small>
                          </div>
                        </div>
                        <Button
                          variant="outline-warning"
                          onClick={handleSaveToDatabase}
                          disabled={loading || (!retConfig && !retCalib) || !isInStandby}
                          style={{ width: '100%', fontWeight: 500 }}
                        >
                          💾 Salvar Banco
                        </Button>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col xs={12} md={6} lg={3}>
                    <Card style={{ background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)', border: '1px solid rgba(143, 173, 21, 0.3)', borderRadius: '12px', height: '100%' }}>
                      <Card.Body>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
                          <span style={{ fontSize: '2rem', marginRight: '12px' }}>🗄️</span>
                          <div>
                            <h6 style={{ margin: 0, color: '#e2e8f0', fontWeight: 600 }}>Buscar no Banco</h6>
                            <small style={{ color: '#94a3b8' }}>Carregar do servidor</small>
                          </div>
                        </div>
                        <Button
                          variant="outline-info"
                          onClick={handleLoadFromDatabase}
                          disabled={loading || loadingConfigs || !isInStandby}
                          style={{ width: '100%', fontWeight: 500 }}
                        >
                          {loadingConfigs ? (
                            <>
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className="me-2"
                              />
                              Buscando...
                            </>
                          ) : (
                            '🗄️ Buscar Banco'
                          )}
                        </Button>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                <CommandHistoryPanel
                  commandLogs={commandLogs}
                  onExportCSV={exportLogsCSV}
                  onClear={() => setCommandLogs([])}
                />
              </div>
            ) : (
              grupos.map(grupo => (
                <div key={grupo.id} className="mb-3" id={grupo.id}>
                  <h6 className="mb-2" style={{ color: grupo.color, fontWeight: 600 }}>
                    {grupo.icon} {grupo.nome}
                  </h6>
                  <Row className="g-2">
                    {/* Botões de operação especiais */}
                    {grupo.nome === 'Operação / Leitura' && (
                      <OperationButtons
                        loading={loading}
                        onRoscon={async () => await sendCommand('ROSCON')}
                        onRoscof={async () => await sendCommand('ROSCOF')}
                        onTampaAbrir={() => handleTampa(1)}
                        onTampaFechar={() => handleTampa(0)}
                        disabled={!isInStandby}
                      />
                    )}

                    {/* Seção de calibração */}
                    {grupo.id === 'calibracao' && (
                      <CalibrationSection
                        loading={loading}
                        comandos={comandos}
                        retConfig={retConfig}
                        cmdToConfigMap={cmdToConfigMap}
                        commandFeedback={commandFeedback}
                        calibrationCommands={calibrationCommands}
                        criticalCommands={criticalCommands}
                        getButtonLabel={getButtonLabel}
                        handleCmdChange={handleCmdChange}
                        handleDialCapxModalOpen={handleDialCapxModalOpen}
                        handleDialCapx2ModalOpen={handleDialCapx2ModalOpen}
                        pendingChanges={pendingChanges}
                        getPendingCalibrationCount={getPendingCalibrationCount}
                        disabled={!isInStandby}
                      />
                    )}

                    {/* Botões de comando genéricos */}
                    {grupo.comandos.map(cmdObj => {
                      const configKey = cmdToConfigMap[cmdObj.cmd];
                      const hasValue = retConfig && configKey && retConfig[configKey] !== undefined;
                      const isCalibration = calibrationCommands.includes(cmdObj.cmd);
                      const feedback = commandFeedback[cmdObj.cmd];
                      const hasPendingChange = pendingChanges[cmdObj.cmd];

                      const getButtonColor = () => {
                        // Se há alteração pendente, usa cor especial (laranja)
                        if (hasPendingChange) return '#f59e0b';
                        if (isCalibration) return 'var(--brand-light-green, #8fad15)';
                        if (cmdObj.params === 0) return 'var(--secondary-color, #6c757d)';
                        if (criticalCommands.includes(cmdObj.cmd)) return 'var(--danger-color, #dc3545)';
                        return 'var(--primary-color, #87A616)';
                      };

                      return (
                        <Col xs={12} sm={6} md={4} lg={3} key={cmdObj.cmd}>
                          <CommandButton
                            cmdObj={cmdObj}
                            loading={loading}
                            onClick={() => handleCmdChange(cmdObj)}
                            getButtonLabel={() => getButtonLabel(cmdObj)}
                            getButtonColor={getButtonColor}
                            hasValue={hasValue}
                            feedback={feedback}
                            isCalibration={isCalibration}
                            criticalCommands={criticalCommands}
                            disabled={!isInStandby}
                          />
                        </Col>
                      );
                    })}
                  </Row>
                </div>
              ))
            )}
          </Col>
        </Row>

        {/* Modais */}
        <BatchConfigModal
          show={showBatchModal}
          onHide={() => setShowBatchModal(false)}
          loading={loading}
          comandos={comandos}
          batchParams={batchParams}
          onBatchParamsChange={setBatchParams}
          onSave={handleBatchSave}
          retConfig={retConfig}
          cmdToConfigMap={cmdToConfigMap}
          calibrationCommands={calibrationCommands}
          criticalCommands={criticalCommands}
        />

        <DialCapxModal
          show={showDialCapxModal}
          onHide={() => setShowDialCapxModal(false)}
          loading={loading}
          dialCapxTable={dialCapxTable}
          onTableChange={setDialCapxTable}
          onClear={() => setDialCapxTable(Array(10).fill().map((_, i) => ({ idx: i + 1, caldial: '', calcapx: '' })))}
          onSave={handleDialCapx1Save}
          title="Calibração (DIAL1 / CAPX1)"
          dialCommand="CALDIAL1"
          capxCommand="CALCAPX1"
          hasChanges={dialCapxTable.some(row =>
            (row.caldial !== '' && row.caldial !== null) ||
            (row.calcapx !== '' && row.calcapx !== null)
          )}
        />

        <DialCapxModal
          show={showDialCapx2Modal}
          onHide={() => setShowDialCapx2Modal(false)}
          loading={loading}
          dialCapxTable={dialCapx2Table}
          onTableChange={setDialCapx2Table}
          onClear={() => setDialCapx2Table(Array(10).fill().map((_, i) => ({ idx: i + 1, caldial: '', calcapx: '' })))}
          onSave={handleDialCapx2Save}
          title="Calibração (DIAL2 / CAPX2)"
          dialCommand="CALDIAL2"
          capxCommand="CALCAPX2"
          hasChanges={dialCapx2Table.some(row =>
            (row.caldial !== '' && row.caldial !== null) ||
            (row.calcapx !== '' && row.calcapx !== null)
          )}
        />

        <CalibrationTableModal
          show={showCalibModal}
          onHide={() => setShowCalibModal(false)}
          loading={loading}
          calibOsc={calibOsc}
          onOscChange={setCalibOsc}
          calibTable={calibTable}
          onTableChange={setCalibTable}
          onClear={() => setCalibTable(Array(10).fill().map((_, i) => ({ idx: i + 1, caldial: '', calcapx: '', chart: i < 4 ? '' : null, offset: '' })))}
          onSave={handleCalibSave}
          hasChanges={calibTable.some(row =>
            (row.caldial !== '' && row.caldial !== null) ||
            (row.calcapx !== '' && row.calcapx !== null) ||
            (row.chart !== '' && row.chart !== null)
          )}
        />

        <CommandParamModal
          show={showParamModal}
          onHide={() => { setShowParamModal(false); setParamValues({}); }}
          loading={loading}
          modalCmdObj={modalCmdObj}
          paramValues={paramValues}
          onParamChange={handleParamChange}
          onSubmit={handleParamSubmit}
          retConfig={retConfig}
          cmdToConfigMap={cmdToConfigMap}
          paramValidation={paramValidation}
          hasChanges={(() => {
            if (!modalCmdObj) return false;
            const configKey = cmdToConfigMap[modalCmdObj.cmd];
            const currentValue = retConfig && configKey ? String(retConfig[configKey]) : '';
            const newValue = paramValues[0] ? String(paramValues[0]).trim() : '';

            // Para comandos com múltiplos parâmetros (UMIRAN1, UMIRAN2)
            if (modalCmdObj.params === 2) {
              return Object.values(paramValues).some(v => v && String(v).trim() !== '');
            }

            // Para comandos de calibração multi-ponto
            if (['CALDIAL1', 'CALCAPX1', 'CALDIAL2', 'CALCAPX2', 'CHART1', 'CHART2'].includes(modalCmdObj.cmd)) {
              return Object.values(paramValues).some(v => v && String(v).trim() !== '');
            }

            // Para NSERIE, normaliza ambos para 5 dígitos
            if (modalCmdObj.cmd === 'NSERIE') {
              const normalizedCurrent = currentValue.padStart(5, '0');
              const normalizedNew = newValue.padStart(5, '0');
              return normalizedNew !== '' && normalizedNew !== normalizedCurrent;
            }

            // Comparação padrão
            return newValue !== '' && newValue !== currentValue;
          })()}
        />

        {/* Modal de confirmação de reboot */}
        <Modal show={showRebootModal} onHide={() => setShowRebootModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>
              ⚠️ Confirmar Reinicialização
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="mb-3">
              Você está prestes a <strong>reiniciar o equipamento</strong>.
            </p>
            <div className="alert alert-warning mb-3">
              <p className="mb-2">
                <strong>⏱️ O que vai acontecer:</strong>
              </p>
              <ul className="mb-0">
                <li>O equipamento será reiniciado</li>
                <li>Aguardaremos até 30 segundos pela reconexão</li>
                <li>As configurações serão recarregadas automaticamente</li>
              </ul>
            </div>
            <p className="mb-0">
              <strong>Deseja continuar com a reinicialização?</strong>
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowRebootModal(false)}
              disabled={loading}
            >
              Cancelar
            </Button>
            <Button
              variant="danger"
              onClick={() => {
                setShowRebootModal(false);
                waitForRebootAndReload();
              }}
              disabled={loading}
            >
              {loading ? 'Reiniciando...' : 'Sim, Reiniciar'}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de confirmação de reset de fábrica */}
        <Modal show={showResetModal} onHide={() => setShowResetModal(false)} centered>
          <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)', border: 'none' }}>
            <Modal.Title style={{ color: 'white', fontWeight: 600 }}>
              <span style={{ fontSize: '1.5rem', marginRight: '8px' }}>⚠️</span>
              Confirmar Reset de Fábrica
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ background: 'linear-gradient(to bottom, #1e293b 0%, #0f172a 100%)', color: '#e2e8f0' }}>
            <div className="alert alert-danger mb-3" style={{ background: 'rgba(220, 53, 69, 0.15)', border: '1px solid rgba(220, 53, 69, 0.3)' }}>
              <p className="mb-2" style={{ fontSize: '1.1rem', fontWeight: 600 }}>
                <strong>🚨 ATENÇÃO: Esta é uma operação crítica!</strong>
              </p>
              <p className="mb-0">
                Você está prestes a <strong style={{ color: '#ef4444' }}>restaurar todas as configurações de fábrica</strong> do equipamento.
              </p>
            </div>

            <div style={{
              background: 'rgba(239, 68, 68, 0.1)',
              border: '1px solid rgba(239, 68, 68, 0.2)',
              borderRadius: '8px',
              padding: '16px',
              marginBottom: '16px'
            }}>
              <p className="mb-2" style={{ fontWeight: 600 }}>
                <strong>⚠️ O que será perdido:</strong>
              </p>
              <ul className="mb-0" style={{ paddingLeft: '20px' }}>
                <li>Todas as configurações personalizadas</li>
                <li>Todos os dados de calibração</li>
                <li>Número de série e parâmetros customizados</li>
                <li>Histórico de operações</li>
              </ul>
            </div>

            <div style={{
              background: 'rgba(251, 191, 36, 0.1)',
              border: '1px solid rgba(251, 191, 36, 0.2)',
              borderRadius: '8px',
              padding: '16px',
              marginBottom: '16px'
            }}>
              <p className="mb-2" style={{ fontWeight: 600 }}>
                <strong>🔄 O que vai acontecer:</strong>
              </p>
              <ul className="mb-0" style={{ paddingLeft: '20px' }}>
                <li>Todas as configurações retornarão aos valores de fábrica</li>
                <li>O equipamento será reiniciado automaticamente</li>
                <li>Será necessário reconfigurar e recalibrar o equipamento</li>
              </ul>
            </div>

            <p className="mb-0" style={{ fontSize: '1.05rem', fontWeight: 600, color: '#f87171' }}>
              ⚠️ Esta ação NÃO PODE ser desfeita. Tem certeza que deseja continuar?
            </p>
          </Modal.Body>
          <Modal.Footer style={{ background: 'linear-gradient(to bottom, #1e293b 0%, #0f172a 100%)', borderTop: '1px solid rgba(148, 163, 184, 0.1)' }}>
            <Button
              variant="secondary"
              onClick={() => setShowResetModal(false)}
              disabled={loading}
              style={{
                background: 'rgba(71, 85, 105, 0.5)',
                border: '1px solid rgba(148, 163, 184, 0.3)',
                color: '#e2e8f0'
              }}
            >
              Cancelar
            </Button>
            <Button
              variant="danger"
              onClick={async () => {
                setShowResetModal(false);
                try {
                  setLoading(true);
                  setError('');

                  // Obter email do usuário do localStorage
                  const userData = JSON.parse(localStorage.getItem('userData'));
                  const userEmail = userData?.email || '';

                  // Validar usuário antes de executar o reset
                  console.log('🔐 Validando permissão para reset de fábrica...');
                  const authResponse = await ApiMServer.post('/user/v1/authenticate', {
                    app: 'API',
                    action: 'Reset de Fábrica',
                    serial: serialFromUrl,
                    email: userEmail,
                    permission: 'supportiot'
                  });

                  // Verifica se a resposta foi 200 (sucesso)
                  if (authResponse.status === 200) {
                    console.log('✅ Permissão concedida, executando reset de fábrica...');
                    await sendCommand('RESET');
                    setResult('✅ Reset de fábrica executado com sucesso! O equipamento será reiniciado.');
                  } else {
                    setError('❌ Sem permissão para executar reset de fábrica.');
                  }
                } catch (err) {
                  // Se o erro for de autenticação (status diferente de 200)
                  if (err.response && err.response.status !== 200) {
                    setError('❌ Sem permissão para executar reset de fábrica.');
                  } else {
                    setError('❌ Erro ao executar reset de fábrica: ' + err.message);
                  }
                } finally {
                  setLoading(false);
                }
              }}
              disabled={loading}
              style={{
                background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
                border: 'none',
                fontWeight: 600
              }}
            >
              {loading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  Executando Reset...
                </>
              ) : (
                'Sim, Executar Reset de Fábrica'
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de confirmação de salvamento em lote */}
        <Modal show={showBatchSaveConfirmModal} onHide={() => setShowBatchSaveConfirmModal(false)} centered>
          <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #1c4220 0%, #8fad15 100%)', border: 'none' }}>
            <Modal.Title style={{ color: 'white', fontWeight: 600 }}>
              <span style={{ fontSize: '1.5rem', marginRight: '8px' }}>💾</span>
              Confirmar Salvamento em Lote
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ background: 'linear-gradient(to bottom, #1e293b 0%, #0f172a 100%)', color: '#e2e8f0' }}>
            <p className="mb-3" style={{ fontSize: '1.05rem' }}>
              Você tem <strong style={{ color: '#8fad15' }}>{Object.keys(pendingChanges).length} alteração(ões) pendente(s)</strong> para enviar ao equipamento.
            </p>

            <div style={{
              background: 'rgba(143, 173, 21, 0.15)',
              border: '1px solid rgba(143, 173, 21, 0.3)',
              borderRadius: '8px',
              padding: '1rem',
              marginBottom: '1rem'
            }}>
              <p className="mb-2" style={{ color: '#8fad15', fontWeight: 600 }}>
                <span style={{ fontSize: '1.2rem', marginRight: '6px' }}>📋</span>
                O que será feito:
              </p>
              <ul className="mb-0" style={{ color: '#cbd5e1', fontSize: '0.95rem', paddingLeft: '1.5rem' }}>
                <li>Enviar {Object.keys(pendingChanges).length} comando(s) ao equipamento</li>
                <li>Reiniciar automaticamente o equipamento</li>
                <li>Aguardar reconexão (até 30 segundos)</li>
                <li>Recarregar as configurações atualizadas</li>
              </ul>
            </div>

            <div style={{
              background: 'rgba(251, 191, 36, 0.15)',
              border: '1px solid rgba(251, 191, 36, 0.3)',
              borderRadius: '8px',
              padding: '1rem'
            }}>
              <p className="mb-2" style={{ color: '#fbbf24', fontWeight: 600 }}>
                <span style={{ fontSize: '1.2rem', marginRight: '6px' }}>⚠️</span>
                Atenção:
              </p>
              <p className="mb-0" style={{ color: '#fcd34d', fontSize: '0.9rem' }}>
                O equipamento ficará temporariamente indisponível durante a reinicialização.
                Aguarde a conclusão do processo.
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer style={{ background: '#0f172a', border: 'none', padding: '1.25rem' }}>
            <Button
              variant="outline-secondary"
              onClick={() => setShowBatchSaveConfirmModal(false)}
              disabled={loading || isSavingBatch}
              style={{ fontWeight: 500, padding: '8px 20px' }}
            >
              Cancelar
            </Button>
            <Button
              onClick={confirmBatchSave}
              disabled={loading || isSavingBatch}
              style={{
                background: 'linear-gradient(135deg, #8fad15 0%, #6d8711 100%)',
                border: 'none',
                fontWeight: 600,
                padding: '8px 24px',
                boxShadow: '0 4px 6px rgba(143, 173, 21, 0.3)'
              }}
            >
              {isSavingBatch ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Salvando...
                </>
              ) : (
                <>💾 Sim, Salvar Tudo</>
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de aviso de mudança de categoria */}
        <Modal show={showCategoryChangeWarningModal} onHide={() => setShowCategoryChangeWarningModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>
              ⚠️ Alterações Pendentes
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="mb-3">
              Você possui <strong>{Object.keys(pendingChanges).length} alteração(ões) pendente(s)</strong>.
            </p>
            <div className="alert alert-info mb-3">
              <p className="mb-2">
                <strong>💡 Para mudar de categoria:</strong>
              </p>
              <ul className="mb-0">
                <li>Salve as alterações pendentes clicando no botão "Enviar todas as alterações"</li>
                <li>Ou descarte as alterações clicando no botão "Descartar"</li>
              </ul>
            </div>
            <p className="mb-0">
              Não é possível mudar de categoria enquanto houver alterações não salvas.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              onClick={() => setShowCategoryChangeWarningModal(false)}
            >
              Entendi
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de confirmação de descarte */}
        <Modal show={showDiscardChangesModal} onHide={() => setShowDiscardChangesModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>
              🗑️ Confirmar Descarte
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="mb-3">
              Você tem <strong>{Object.keys(pendingChanges).length} alteração(ões) pendente(s)</strong>.
            </p>
            <div className="alert alert-warning mb-3">
              <p className="mb-2">
                <strong>⚠️ Atenção:</strong>
              </p>
              <ul className="mb-0">
                <li>Todas as alterações serão perdidas</li>
                <li>Esta ação não pode ser desfeita</li>
                <li>Você precisará refazer as edições se necessário</li>
              </ul>
            </div>
            <p className="mb-0">
              <strong>Deseja realmente descartar todas as alterações?</strong>
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowDiscardChangesModal(false)}
            >
              Cancelar
            </Button>
            <Button
              variant="danger"
              onClick={confirmDiscardChanges}
            >
              Sim, Descartar Tudo
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de conflito de importação */}
        <Modal show={showConflictModal} onHide={() => setShowConflictModal(false)} centered>
          <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', border: 'none' }}>
            <Modal.Title style={{ color: 'white', fontWeight: 600 }}>
              <span style={{ fontSize: '1.5rem', marginRight: '8px' }}>⚠️</span>
              Conflito Detectado
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ background: 'linear-gradient(to bottom, #1e293b 0%, #0f172a 100%)', color: '#e2e8f0' }}>
            <p className="mb-3" style={{ fontSize: '1.05rem' }}>
              Você possui <strong style={{ color: '#f59e0b' }}>{Object.keys(pendingChanges).length} alteração(ões) pendente(s)</strong> não salva(s).
            </p>

            <div style={{
              background: 'rgba(251, 158, 11, 0.15)',
              border: '1px solid rgba(251, 158, 11, 0.3)',
              borderRadius: '8px',
              padding: '1rem',
              marginBottom: '1rem'
            }}>
              <p className="mb-2" style={{ color: '#fbbf24', fontWeight: 600 }}>
                <span style={{ fontSize: '1.2rem', marginRight: '6px' }}>❓</span>
                O que deseja fazer?
              </p>
              <ul className="mb-0" style={{ color: '#cbd5e1', fontSize: '0.95rem', paddingLeft: '1.5rem' }}>
                <li><strong>Substituir:</strong> Descarta as alterações pendentes e carrega as do arquivo</li>
                <li><strong>Mesclar:</strong> Mantém as alterações pendentes e adiciona as do arquivo</li>
              </ul>
            </div>

            <p className="mb-0" style={{ fontSize: '0.9rem', color: '#94a3b8' }}>
              💡 Você também pode cancelar e salvar suas alterações pendentes antes de importar.
            </p>
          </Modal.Body>
          <Modal.Footer style={{ background: '#0f172a', border: 'none', padding: '1.25rem' }}>
            <Button
              variant="outline-secondary"
              onClick={() => setShowConflictModal(false)}
              style={{ fontWeight: 500, padding: '8px 20px' }}
            >
              Cancelar
            </Button>
            <Button
              onClick={handleConflictReplace}
              style={{
                background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                border: 'none',
                fontWeight: 600,
                padding: '8px 20px'
              }}
            >
              🗑️ Substituir
            </Button>
            <Button
              onClick={handleConflictMerge}
              style={{
                background: 'linear-gradient(135deg, #8fad15 0%, #6d8711 100%)',
                border: 'none',
                fontWeight: 600,
                padding: '8px 20px'
              }}
            >
              🔀 Mesclar
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de salvar no banco de dados */}
        <Modal show={showSaveConfigModal} onHide={() => setShowSaveConfigModal(false)} centered>
          <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', border: 'none' }}>
            <Modal.Title style={{ color: 'white', fontWeight: 600 }}>
              <span style={{ fontSize: '1.5rem', marginRight: '8px' }}>💾</span>
              Salvar Configuração no Banco
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ background: 'linear-gradient(to bottom, #1e293b 0%, #0f172a 100%)', color: '#e2e8f0' }}>
            <div style={{
              background: 'rgba(143, 173, 21, 0.15)',
              border: '1px solid rgba(143, 173, 21, 0.3)',
              borderRadius: '8px',
              padding: '1rem',
              marginBottom: '1rem'
            }}>
              <p className="mb-2" style={{ color: '#8fad15', fontWeight: 600 }}>
                <span style={{ fontSize: '1.2rem', marginRight: '6px' }}>ℹ️</span>
                Informações do Equipamento
              </p>
              <Row>
                <Col xs={6}>
                  <small style={{ color: '#94a3b8' }}>Serial:</small>
                  <div style={{ color: '#cbd5e1', fontWeight: 500 }}>{serialFromUrl}</div>
                </Col>
                <Col xs={6}>
                  <small style={{ color: '#94a3b8' }}>Data/Hora:</small>
                  <div style={{ color: '#cbd5e1', fontWeight: 500 }}>
                    {new Date().toLocaleString('pt-BR')}
                  </div>
                </Col>
              </Row>
            </div>

            <div className="mb-3">
              <label htmlFor="config-description" style={{ color: '#cbd5e1', marginBottom: '0.5rem', display: 'block', fontWeight: 500 }}>
                Descrição da Configuração (opcional)
              </label>
              <input
                type="text"
                id="config-description"
                className="form-control"
                placeholder="Ex: Configuração para Soja - Safra 2026"
                value={configDescription}
                onChange={(e) => setConfigDescription(e.target.value)}
                maxLength={200}
                style={{
                  background: 'rgba(71, 85, 105, 0.3)',
                  border: '1px solid rgba(148, 163, 184, 0.3)',
                  color: '#e2e8f0',
                  borderRadius: '6px',
                  padding: '0.5rem 0.75rem'
                }}
              />
              <small style={{ color: '#94a3b8', display: 'block', marginTop: '0.25rem' }}>
                {configDescription.length}/200 caracteres
              </small>
            </div>

            <div style={{
              background: 'rgba(59, 130, 246, 0.15)',
              border: '1px solid rgba(59, 130, 246, 0.3)',
              borderRadius: '8px',
              padding: '1rem'
            }}>
              <p className="mb-2" style={{ color: '#60a5fa', fontWeight: 600 }}>
                <span style={{ fontSize: '1.2rem', marginRight: '6px' }}>📦</span>
                O que será salvo:
              </p>
              <ul className="mb-0" style={{ color: '#cbd5e1', fontSize: '0.9rem', paddingLeft: '1.5rem' }}>
                <li>Todas as configurações atuais do equipamento</li>
                <li>Todas as calibrações atuais (OSC1 e OSC2)</li>
                {Object.keys(pendingChanges).length > 0 && (
                  <li style={{ color: '#fbbf24' }}>
                    {Object.keys(pendingChanges).length} alteração(ões) pendente(s) não salva(s)
                  </li>
                )}
              </ul>
            </div>
          </Modal.Body>
          <Modal.Footer style={{ background: '#0f172a', border: 'none', padding: '1.25rem' }}>
            <Button
              variant="outline-secondary"
              onClick={() => {
                setShowSaveConfigModal(false);
                setConfigDescription('');
              }}
              disabled={loading}
              style={{ fontWeight: 500, padding: '8px 20px' }}
            >
              Cancelar
            </Button>
            <Button
              onClick={confirmSaveToDatabase}
              disabled={loading}
              style={{
                background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                border: 'none',
                fontWeight: 600,
                padding: '8px 24px',
                boxShadow: '0 4px 6px rgba(245, 158, 11, 0.3)'
              }}
            >
              {loading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  Salvando...
                </>
              ) : (
                '💾 Salvar no Banco'
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de carregar do banco de dados */}
        <Modal show={showLoadConfigModal} onHide={() => setShowLoadConfigModal(false)} centered size="lg">
          <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)', border: 'none' }}>
            <Modal.Title style={{ color: 'white', fontWeight: 600 }}>
              <span style={{ fontSize: '1.5rem', marginRight: '8px' }}>🗄️</span>
              Configurações Salvas - Serial {serialFromUrl}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ background: 'linear-gradient(to bottom, #1e293b 0%, #0f172a 100%)', color: '#e2e8f0', maxHeight: '500px', overflowY: 'auto' }}>
            {savedConfigs.length === 0 ? (
              <div style={{
                textAlign: 'center',
                padding: '2rem',
                color: '#94a3b8'
              }}>
                <span style={{ fontSize: '3rem', display: 'block', marginBottom: '1rem' }}>📭</span>
                <p>Nenhuma configuração salva encontrada.</p>
              </div>
            ) : (
              <div className="d-grid gap-3">
                {savedConfigs.map((config, index) => (
                  <Card
                    key={config._id || config.id || index}
                    style={{
                      background: 'rgba(71, 85, 105, 0.3)',
                      border: '1px solid rgba(148, 163, 184, 0.3)',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = 'rgba(143, 173, 21, 0.2)';
                      e.currentTarget.style.borderColor = 'rgba(143, 173, 21, 0.5)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'rgba(71, 85, 105, 0.3)';
                      e.currentTarget.style.borderColor = 'rgba(148, 163, 184, 0.3)';
                    }}
                  >
                    <Card.Body>
                      <Row className="align-items-center">
                        <Col xs={9}>
                          <div style={{ marginBottom: '0.5rem' }}>
                            <span style={{ fontSize: '1.2rem', marginRight: '0.5rem' }}>📋</span>
                            <strong style={{ color: '#e2e8f0', fontSize: '1rem' }}>
                              {config.descricao || 'Sem descrição'}
                            </strong>
                          </div>
                          <div style={{ fontSize: '0.85rem', color: '#94a3b8' }}>
                            <div>
                              <span style={{ marginRight: '1rem' }}>
                                🕒 {new Date(config.timestamp).toLocaleString('pt-BR')}
                              </span>
                            </div>
                            <div style={{ marginTop: '0.25rem' }}>
                              {config.configuracao && Object.keys(config.configuracao).length > 0 && (
                                <span style={{ marginRight: '1rem' }}>
                                  ⚙️ {Object.keys(config.configuracao).length} configs
                                </span>
                              )}
                              {config.calibracao && Object.keys(config.calibracao).length > 0 && (
                                <span>
                                  🎯 {Object.keys(config.calibracao).length} calibs
                                </span>
                              )}
                            </div>
                          </div>
                        </Col>
                        <Col xs={12} className="mt-2">
                          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                            <Button
                              variant="outline-info"
                              size="sm"
                              onClick={() => handleViewConfig(config)}
                              disabled={loading}
                              style={{
                                fontWeight: 500,
                                padding: '6px 12px',
                                flex: '1',
                                minWidth: '100px'
                              }}
                            >
                              👁️ Ver Detalhes
                            </Button>
                            <Button
                              variant="outline-success"
                              size="sm"
                              onClick={() => confirmLoadFromDatabase(config)}
                              disabled={loading || !isInStandby}
                              style={{
                                fontWeight: 600,
                                padding: '6px 12px',
                                flex: '1',
                                minWidth: '100px'
                              }}
                              title={!isInStandby ? 'Equipamento precisa estar liberado para configuração' : 'Aplicar configuração diretamente no equipamento'}
                            >
                              {loading ? (
                                <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                />
                              ) : (
                                '⚡ Aplicar'
                              )}
                            </Button>
                            <Button
                              variant="outline-danger"
                              size="sm"
                              onClick={() => handleDeleteConfig(config)}
                              disabled={loading || deletingConfig}
                              style={{
                                fontWeight: 500,
                                padding: '6px 12px',
                                flex: '1',
                                minWidth: '100px'
                              }}
                            >
                              🗑️ Excluir
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                ))}
              </div>
            )}
          </Modal.Body>
          <Modal.Footer style={{ background: '#0f172a', border: 'none', padding: '1.25rem' }}>
            <Button
              variant="outline-secondary"
              onClick={() => setShowLoadConfigModal(false)}
              style={{ fontWeight: 500, padding: '8px 20px' }}
            >
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de visualização de configuração */}
        <Modal show={showViewConfigModal} onHide={() => setShowViewConfigModal(false)} centered size="xl">
          <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)', border: 'none' }}>
            <Modal.Title style={{ color: 'white', fontWeight: 600 }}>
              <span style={{ fontSize: '1.5rem', marginRight: '8px' }}>👁️</span>
              Detalhes da Configuração
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ background: 'linear-gradient(to bottom, #1e293b 0%, #0f172a 100%)', color: '#e2e8f0', maxHeight: '600px', overflowY: 'auto' }}>
            {viewConfigData && (
              <>
                {/* Informações básicas */}
                <div style={{
                  background: 'rgba(99, 102, 241, 0.15)',
                  border: '1px solid rgba(99, 102, 241, 0.3)',
                  borderRadius: '8px',
                  padding: '1rem',
                  marginBottom: '1rem'
                }}>
                  <Row>
                    <Col xs={12} md={6}>
                      <div className="mb-3">
                        <small style={{ color: '#94a3b8', display: 'block', marginBottom: '4px' }}>📋 Descrição:</small>
                        <div style={{ color: '#e2e8f0', fontWeight: 500 }}>
                          {viewConfigData.descricao || 'Sem descrição'}
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} md={3}>
                      <div className="mb-3">
                        <small style={{ color: '#94a3b8', display: 'block', marginBottom: '4px' }}>📱 Serial:</small>
                        <div style={{ color: '#e2e8f0', fontWeight: 500 }}>
                          {viewConfigData.serial}
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} md={3}>
                      <div className="mb-3">
                        <small style={{ color: '#94a3b8', display: 'block', marginBottom: '4px' }}>🕒 Data/Hora:</small>
                        <div style={{ color: '#e2e8f0', fontWeight: 500, fontSize: '0.9rem' }}>
                          {new Date(viewConfigData.timestamp).toLocaleString('pt-BR')}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>

                {/* Configurações */}
                {viewConfigData.configuracao && Object.keys(viewConfigData.configuracao).length > 0 && (
                  <div style={{
                    background: 'rgba(143, 173, 21, 0.15)',
                    border: '1px solid rgba(143, 173, 21, 0.3)',
                    borderRadius: '8px',
                    padding: '1rem',
                    marginBottom: '1rem'
                  }}>
                    <h6 style={{ color: '#8fad15', fontWeight: 600, marginBottom: '1rem' }}>
                      ⚙️ Configurações ({Object.keys(viewConfigData.configuracao).length})
                    </h6>
                    <div style={{
                      background: 'rgba(0, 0, 0, 0.2)',
                      borderRadius: '6px',
                      padding: '1rem',
                      maxHeight: '300px',
                      overflowY: 'auto'
                    }}>
                      <pre style={{
                        color: '#cbd5e1',
                        fontSize: '0.85rem',
                        margin: 0,
                        fontFamily: 'Monaco, Consolas, monospace',
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word'
                      }}>
                        {JSON.stringify(viewConfigData.configuracao, null, 2)}
                      </pre>
                    </div>
                  </div>
                )}

                {/* Calibrações */}
                {viewConfigData.calibracao && Object.keys(viewConfigData.calibracao).length > 0 && (
                  <div style={{
                    background: 'rgba(59, 130, 246, 0.15)',
                    border: '1px solid rgba(59, 130, 246, 0.3)',
                    borderRadius: '8px',
                    padding: '1rem',
                    marginBottom: '1rem'
                  }}>
                    <h6 style={{ color: '#60a5fa', fontWeight: 600, marginBottom: '1rem' }}>
                      🎯 Calibrações ({Object.keys(viewConfigData.calibracao).length})
                    </h6>
                    <div style={{
                      background: 'rgba(0, 0, 0, 0.2)',
                      borderRadius: '6px',
                      padding: '1rem',
                      maxHeight: '300px',
                      overflowY: 'auto'
                    }}>
                      <pre style={{
                        color: '#cbd5e1',
                        fontSize: '0.85rem',
                        margin: 0,
                        fontFamily: 'Monaco, Consolas, monospace',
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word'
                      }}>
                        {JSON.stringify(viewConfigData.calibracao, null, 2)}
                      </pre>
                    </div>
                  </div>
                )}

                {/* Alterações Pendentes */}
                {viewConfigData.alteracoesPendentes && Object.keys(viewConfigData.alteracoesPendentes).length > 0 && (
                  <div style={{
                    background: 'rgba(251, 191, 36, 0.15)',
                    border: '1px solid rgba(251, 191, 36, 0.3)',
                    borderRadius: '8px',
                    padding: '1rem'
                  }}>
                    <h6 style={{ color: '#fbbf24', fontWeight: 600, marginBottom: '1rem' }}>
                      ⚠️ Alterações Pendentes ({Object.keys(viewConfigData.alteracoesPendentes).length})
                    </h6>
                    <div style={{
                      background: 'rgba(0, 0, 0, 0.2)',
                      borderRadius: '6px',
                      padding: '1rem',
                      maxHeight: '300px',
                      overflowY: 'auto'
                    }}>
                      <pre style={{
                        color: '#cbd5e1',
                        fontSize: '0.85rem',
                        margin: 0,
                        fontFamily: 'Monaco, Consolas, monospace',
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word'
                      }}>
                        {JSON.stringify(viewConfigData.alteracoesPendentes, null, 2)}
                      </pre>
                    </div>
                  </div>
                )}
              </>
            )}
          </Modal.Body>
          <Modal.Footer style={{ background: '#0f172a', border: 'none', padding: '1.25rem' }}>
            <Button
              variant="outline-secondary"
              onClick={() => setShowViewConfigModal(false)}
              style={{ fontWeight: 500, padding: '8px 20px' }}
            >
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de confirmação de exclusão */}
        <Modal show={showDeleteConfigModal} onHide={() => setShowDeleteConfigModal(false)} centered>
          <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)', border: 'none' }}>
            <Modal.Title style={{ color: 'white', fontWeight: 600 }}>
              <span style={{ fontSize: '1.5rem', marginRight: '8px' }}>🗑️</span>
              Confirmar Exclusão
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ background: 'linear-gradient(to bottom, #1e293b 0%, #0f172a 100%)', color: '#e2e8f0' }}>
            {deleteConfigData && (
              <>
                <div style={{
                  background: 'rgba(239, 68, 68, 0.15)',
                  border: '1px solid rgba(239, 68, 68, 0.3)',
                  borderRadius: '8px',
                  padding: '1rem',
                  marginBottom: '1rem'
                }}>
                  <p className="mb-2" style={{ color: '#f87171', fontWeight: 600 }}>
                    <span style={{ fontSize: '1.2rem', marginRight: '6px' }}>⚠️</span>
                    Você está prestes a excluir esta configuração:
                  </p>
                  <div style={{ color: '#cbd5e1', paddingLeft: '1.5rem' }}>
                    <div className="mb-2">
                      <strong>📋 Descrição:</strong> {deleteConfigData.descricao || 'Sem descrição'}
                    </div>
                    <div className="mb-2">
                      <strong>🕒 Data:</strong> {new Date(deleteConfigData.timestamp).toLocaleString('pt-BR')}
                    </div>
                    <div>
                      <strong>📊 Dados:</strong>{' '}
                      {deleteConfigData.configuracao && Object.keys(deleteConfigData.configuracao).length > 0 && (
                        <span>{Object.keys(deleteConfigData.configuracao).length} configs</span>
                      )}
                      {deleteConfigData.configuracao && deleteConfigData.calibracao && 
                       Object.keys(deleteConfigData.configuracao).length > 0 && 
                       Object.keys(deleteConfigData.calibracao).length > 0 && ' + '}
                      {deleteConfigData.calibracao && Object.keys(deleteConfigData.calibracao).length > 0 && (
                        <span>{Object.keys(deleteConfigData.calibracao).length} calibs</span>
                      )}
                    </div>
                  </div>
                </div>

                <div style={{
                  background: 'rgba(251, 191, 36, 0.15)',
                  border: '1px solid rgba(251, 191, 36, 0.3)',
                  borderRadius: '8px',
                  padding: '1rem'
                }}>
                  <p className="mb-0" style={{ color: '#fbbf24', fontSize: '0.95rem' }}>
                    <strong>⚠️ Atenção:</strong> Esta ação não pode ser desfeita. A configuração será permanentemente removida do banco de dados.
                  </p>
                </div>
              </>
            )}
          </Modal.Body>
          <Modal.Footer style={{ background: '#0f172a', border: 'none', padding: '1.25rem' }}>
            <Button
              variant="outline-secondary"
              onClick={() => {
                setShowDeleteConfigModal(false);
                setDeleteConfigData(null);
              }}
              disabled={deletingConfig}
              style={{ fontWeight: 500, padding: '8px 20px' }}
            >
              Cancelar
            </Button>
            <Button
              onClick={confirmDeleteConfig}
              disabled={deletingConfig}
              style={{
                background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                border: 'none',
                fontWeight: 600,
                padding: '8px 24px',
                boxShadow: '0 4px 6px rgba(239, 68, 68, 0.3)'
              }}
            >
              {deletingConfig ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  Excluindo...
                </>
              ) : (
                '🗑️ Sim, Excluir'
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de confirmação de importação */}
        <Modal show={showImportModal} onHide={() => setShowImportModal(false)} centered size="lg">
          <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)', border: 'none' }}>
            <Modal.Title style={{ color: 'white', fontWeight: 600 }}>
              <span style={{ fontSize: '1.5rem', marginRight: '8px' }}>📤</span>
              Confirmar Importação
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ background: 'linear-gradient(to bottom, #1e293b 0%, #0f172a 100%)', color: '#e2e8f0' }}>
            {importData && (
              <>
                <div style={{
                  background: 'rgba(59, 130, 246, 0.15)',
                  border: '1px solid rgba(59, 130, 246, 0.3)',
                  borderRadius: '8px',
                  padding: '1rem',
                  marginBottom: '1rem'
                }}>
                  <p className="mb-2" style={{ color: '#60a5fa', fontWeight: 600 }}>
                    <span style={{ fontSize: '1.2rem', marginRight: '6px' }}>ℹ️</span>
                    Informações do Arquivo
                  </p>
                  <Row>
                    <Col xs={6}>
                      <small style={{ color: '#94a3b8' }}>Serial:</small>
                      <div style={{ color: '#cbd5e1', fontWeight: 500 }}>{importData.equipamento.serial}</div>
                    </Col>
                    <Col xs={6}>
                      <small style={{ color: '#94a3b8' }}>Data Exportação:</small>
                      <div style={{ color: '#cbd5e1', fontWeight: 500, fontSize: '0.85rem' }}>
                        {importData.equipamento.dataExportacaoLocal || new Date(importData.equipamento.dataExportacao).toLocaleString('pt-BR')}
                      </div>
                    </Col>
                  </Row>
                </div>

                <div style={{
                  background: 'rgba(143, 173, 21, 0.15)',
                  border: '1px solid rgba(143, 173, 21, 0.3)',
                  borderRadius: '8px',
                  padding: '1rem',
                  marginBottom: '1rem'
                }}>
                  <p className="mb-3" style={{ color: '#8fad15', fontWeight: 600 }}>
                    <span style={{ fontSize: '1.2rem', marginRight: '6px' }}>📋</span>
                    Selecione o que deseja importar:
                  </p>

                  <div className="form-check mb-2" style={{ paddingLeft: '1.5rem' }}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={importOptions.config}
                      onChange={(e) => setImportOptions(prev => ({ ...prev, config: e.target.checked }))}
                      id="import-config-checkbox"
                      disabled={!importData.configuracao || Object.keys(importData.configuracao).length === 0}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="import-config-checkbox"
                      style={{ color: '#cbd5e1', cursor: 'pointer' }}
                    >
                      <strong>Configurações</strong>
                      <small style={{ display: 'block', color: '#94a3b8', marginTop: '2px' }}>
                        {importData.configuracao && Object.keys(importData.configuracao).length > 0
                          ? `${Object.keys(importData.configuracao).length} parâmetro(s) de configuração`
                          : 'Nenhuma configuração disponível'}
                      </small>
                    </label>
                  </div>

                  <div className="form-check" style={{ paddingLeft: '1.5rem' }}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={importOptions.calib}
                      onChange={(e) => setImportOptions(prev => ({ ...prev, calib: e.target.checked }))}
                      id="import-calib-checkbox"
                      disabled={!importData.calibracao || Object.keys(importData.calibracao).length === 0}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="import-calib-checkbox"
                      style={{ color: '#cbd5e1', cursor: 'pointer' }}
                    >
                      <strong>Calibrações</strong>
                      <small style={{ display: 'block', color: '#94a3b8', marginTop: '2px' }}>
                        {importData.calibracao && Object.keys(importData.calibracao).length > 0
                          ? `${Object.keys(importData.calibracao).length} parâmetro(s) de calibração`
                          : 'Nenhuma calibração disponível'}
                      </small>
                    </label>
                  </div>
                </div>

                <div style={{
                  background: 'rgba(251, 191, 36, 0.15)',
                  border: '1px solid rgba(251, 191, 36, 0.3)',
                  borderRadius: '8px',
                  padding: '1rem'
                }}>
                  <p className="mb-2" style={{ color: '#fbbf24', fontWeight: 600 }}>
                    <span style={{ fontSize: '1.2rem', marginRight: '6px' }}>💡</span>
                    O que vai acontecer:
                  </p>
                  <ul className="mb-0" style={{ color: '#fcd34d', fontSize: '0.9rem', paddingLeft: '1.5rem' }}>
                    <li>As configurações serão carregadas como <strong>alterações pendentes</strong></li>
                    <li>Você poderá revisar antes de enviar ao equipamento</li>
                    <li>Clique em "Salvar Todas as Alterações" para aplicar</li>
                  </ul>
                </div>
              </>
            )}
          </Modal.Body>
          <Modal.Footer style={{ background: '#0f172a', border: 'none', padding: '1.25rem' }}>
            <Button
              variant="outline-secondary"
              onClick={() => {
                setShowImportModal(false);
                setImportData(null);
                setImportOptions({ config: true, calib: true });
              }}
              style={{ fontWeight: 500, padding: '8px 20px' }}
            >
              Cancelar
            </Button>
            <Button
              onClick={confirmImport}
              disabled={!importOptions.config && !importOptions.calib}
              style={{
                background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                border: 'none',
                fontWeight: 600,
                padding: '8px 24px',
                boxShadow: '0 4px 6px rgba(59, 130, 246, 0.3)'
              }}
            >
              📤 Confirmar Importação
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Botão fixo para salvar alterações pendentes */}
        {showBatchSaveButton && (
          <div
            style={{
              position: 'fixed',
              bottom: '15px',
              left: '50%',
              transform: 'translateX(-50%)',
              zIndex: 1050,
              background: 'linear-gradient(135deg, #1c4220 0%, #8fad15 100%)',
              padding: '10px 18px',
              borderRadius: '8px',
              boxShadow: '0 6px 18px rgba(0, 0, 0, 0.25)',
              display: 'flex',
              flexDirection: window.innerWidth < 768 ? 'column' : 'row',
              alignItems: 'center',
              gap: window.innerWidth < 768 ? '8px' : '12px',
              maxWidth: '90vw',
              width: window.innerWidth < 768 ? 'calc(100% - 30px)' : 'auto',
              animation: 'slideUp 0.3s ease-out',
              willChange: 'transform'
            }}
          >
            <div style={{
              color: 'white',
              fontWeight: 600,
              fontSize: window.innerWidth < 768 ? '0.8rem' : '0.85rem',
              textAlign: window.innerWidth < 768 ? 'center' : 'left'
            }}>
              📝 {Object.keys(pendingChanges).length} alteração(ões) pendente(s)
            </div>
            <div style={{
              display: 'flex',
              gap: '8px',
              width: window.innerWidth < 768 ? '100%' : 'auto',
              flexWrap: 'wrap',
              justifyContent: 'center'
            }}>
              <Button
                onClick={handleClearPendingChanges}
                disabled={isSavingBatch || loading}
                size="sm"
                style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.2)',
                  color: 'white',
                  border: '1px solid rgba(255, 255, 255, 0.3)',
                  fontWeight: 500,
                  padding: '6px 12px',
                  fontSize: '0.8rem',
                  flex: window.innerWidth < 768 ? '1' : 'initial'
                }}
              >
                ❌ Descartar
              </Button>
              <Button
                onClick={handleSaveAllPendingChanges}
                disabled={isSavingBatch || loading || !isInStandby}
                size="sm"
                style={{
                  backgroundColor: 'white',
                  color: '#1c4220',
                  border: 'none',
                  fontWeight: 600,
                  padding: '6px 14px',
                  fontSize: '0.8rem',
                  flex: window.innerWidth < 768 ? '1' : 'initial'
                }}
                title={!isInStandby ? 'Equipamento precisa estar liberado para configuração' : ''}
              >
                {isSavingBatch ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-1"
                    />
                    Enviando...
                  </>
                ) : (
                  '📤 Enviar alterações'
                )}
              </Button>
            </div>
          </div>
        )}
      </Card>

      <style>{`
        @keyframes slideUp {
          from {
            transform: translateX(-50%) translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateX(-50%) translateY(0);
            opacity: 1;
          }
        }
      `}</style>
    </Page>
  );
};

export default ConectedIot;


